import React, { Component } from 'react';
import { Form, Button, Row, Col, Modal } from 'react-bootstrap';
import Layout from '../Components/Layout';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import AddRawsModal from '../Components/AddRawsModal';
import ImageGrid from "../Components/ImageGrid";
import NotesSection from '../Components/NotesSection';
import AuditLogSection from '../Components/AuditLogSection';

const formStyles = `
.form-section {
    background: white;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    margin-bottom: 20px;
}
.section-header {
    padding: 20px 24px;
    border-bottom: 1px solid #e5e7eb;
    background: #f8f9fa;
    border-radius: 12px 12px 0 0;
}
.section-content {
    padding: 24px;
}
.form-label {
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;
    font-size: 14px;
}
.form-control, .form-select {
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 10px 12px;
    font-size: 14px;
    width: 100%;
    height: auto;
}
.form-control:focus, .form-select:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.form-select {
    min-height: calc(1.5em + 20px + 2px);
    background-position: right 12px center;
    background-size: 16px 12px;
}
.custom-dropdown {
    position: relative;
}
.custom-dropdown .form-select {
    padding-right: 40px;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right .75rem center;
    background-size: 16px 12px;
}

.searchable-dropdown {
    position: relative;
}
.dropdown-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 300px;
    overflow-y: auto;
    background: white;
    border: 1px solid #dee2e6;
    border-top: none;
    border-radius: 0 0 6px 6px;
    z-index: 1000;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.dropdown-item-custom {
    padding: 10px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f3f4f6;
    font-size: 14px;
}
.dropdown-item-custom:hover {
    background-color: #f3f4f6;
}
.dropdown-item-custom:last-child {
    border-bottom: none;
}
.no-results {
    padding: 10px 12px;
    text-align: center;
    color: #6b7280;
    font-size: 14px;
}

.searchable-dropdown-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #dee2e6;
    border-top: none;
    border-radius: 0 0 4px 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.searchable-dropdown-item {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f8f9fa;
    font-size: 14px;
    color: #495057;
}

.searchable-dropdown-item:hover {
    background-color: #f8f9fa;
}

.searchable-dropdown-item:last-child {
    border-bottom: none;
}

.searchable-dropdown-no-results {
    padding: 8px 12px;
    color: #6c757d;
    font-style: italic;
    text-align: center;
}

.hide-me {
    display:none;
}
`;

class AddNewFormula extends Component {
    state = {
        // Form data
        selectedRfq: null,
        historyId: null,
        company: '',
        formulaNumber: '', // Will be auto-generated
        formulaName: '',
        formulaLookupInput: '',
        formulaLookupLoading: false,
        formulaLookupError: '',
        productName: '',
        form: 'Select form',
        servingSize: '',
        servingsPerUnit: '',
        isEditMode: false, // Track if we're in edit mode

        // Sales Rep and Assigned To
        salesRep: '',
        assignedTo: '',
        orderType: '',
        itemNumber: '',
        sharepointLink: '',

        // Capsule details
        capsuleSize: '0',
        capsuleSpecifications: '',
        capsuleWeight: '',
        capsuleColor: '',
        capsuleFillWeight: '',
        capsuleRange: '',
        capsuleTotalWeight: '',

        // Tablet details
        tabletWeight: '',
        tabletShape: '',

        // Liquid details
        liquidDensity: '',

        // UI state
        loading: false,
        savingDraft: false,
        availableRfqs: [],
        sfpImages:[],
        loadingRfqs: true,
        errors: {},
        salesReps: [],
        showAllNotes: false,

        // Notes
        notesList: [],
        currentNote: '',

        // Testing
        testingItems: [],

        // Modal state
        showAddRawsModal: false,
        showCalculatorModal: false,
        calculatorData: {
            activeInactiveOptions: [],
            activeInactiveOption: '',
            amount: '',
            unit: '',
            limitOptions: [],
            selectedLimit: '',
            limit: 0,
            amountRequiredPerServing: 0,
            amountRequiredPerCapsule: 0,
            finalAmount: 0
        },
        calculatorTargetIndex: null,
        calculatorTargetIndexOverage: 100,

        // Parts data
        originalIngredientParts: [], // Store original 60000-69999 parts from backend
        originalPackagingParts: [], // Store original 70000-89999 parts from backend
        filteredIngredientParts: [],
        filteredPackagingParts: [],
        loadingParts: false,

        // Searchable dropdown state
        searchableDropdowns: {
            ingredient: {}, // Will store { index: { searchTerm: '', isOpen: false, selectedPart: null } }
            packaging: {}   // Will store { index: { searchTerm: '', isOpen: false, selectedPart: null } }
        },

        // Simple ingredient search state (like AddNewRFQ.js)
        ingredientSearch: '',
        showIngredientDropdown: false,
        filteredIngredients: [],
        activeDropdownIndex: null, // Track which row's dropdown is open

        // Packaging search state (similar to ingredient search)
        showPackagingDropdown: false,
        activePackagingDropdownIndex: null, // Track which packaging row's dropdown is open

        // Capsule search state (for single capsule record)
        showCapsuleDropdown: false,
        filteredCapsuleParts: [],

        // New ingredient part fields
        newIngredientPartId: '',
        newIngredientPartName: '',

        // Ingredient parts state
        ingredientParts: [
            {
                partId: '',
                partName: '',
                amount: '',
                overage: '100',
                amountPerServing: '',
                unit: '',
                source: '',
                Source: 1,
                IsCsm: 0,
                filteredParts: [] // Per-row filtered parts
            }
        ],

        // Capsule state (single record only)
        capsule: {
            RfqCapsuleId: 0,
            RfqId: 0,
            RawsId: 0,
            PartID: '',
            PartName: '',
            filteredParts: []
        },

        // Packaging parts state
        packagingParts: [
            {
                RfqPackagingPartId: 0,
                RfqId: 0,
                RawsId: 0,
                PartID: '',
                PartName: '',
                Amount: '',
                OverageCost: '',
                IsCsm: '',
                RfqServingUnitId: 0,
                filteredParts: [] // Per-row filtered parts
            }
        ],
        servingUnits: [] // Serving units from selected RFQ (readonly)
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const editId = urlParams.get('id'); // For edit mode
        const rfqId = urlParams.get('rfqId'); // For new formula with specific RFQ
        const isEditMode = window.location.pathname === '/formula/edit';
        const historyId = urlParams.get('historyId');


        // Set edit mode state
        this.setState({ isEditMode });

        this.setState({ historyId }, () => {
            // Check if we're in edit mode (coming from save/submit)
            if (editId) {
                // In edit mode, the id is the RFQ ID
                this.loadSpecificRfq(editId);
            } else if (rfqId) {
                // Load specific RFQ data
                this.loadSpecificRfq(rfqId);
            } else if (historyId) {
                // Load specific RFQ data
                this.loadSpecificRfq(historyId);
            }
            else {
                // console.log('Loading available RFQs (normal flow)...');
                // Load available RFQs with status 3 (normal flow)
                this.loadAvailableRfqs();
            }

            // Load all parts for filtering
            this.loadAllParts();

            // Load sales reps from API
            this.loadSalesReps();

            // Check if we need to calculate fill weight after component mounts
            setTimeout(() => {
                this.checkIfNeedsFillWeightCalculation();
            }, 500);
        });


    }

    loadSalesReps = () => {
        axios.get('assigned-to')
            .then(response => {
                const salesReps = response.data.data || [];
                this.setState({ salesReps });
            })
            .catch(error => {
                console.error('Error loading assigned to:', error);
                this.setState({ salesReps: [] });
            });
    }

    loadRfq = (rfqId) => {
        let url = `/rfq/${rfqId}`;
        if(this.state.historyId)
        {
            url = `/rfq-history/${rfqId}`;
        }
        axios.get(url)
            .then(response => {

                const rfq = response.data.rfq || response.data;
                const ingredients = response.data.ingredients || [];
                const testing = response.data.testing || [];
                const tiers = response.data.tiers || [];
                const rfqIngredientParts = response.data.rfqingredientparts || [];
                const rfqCapsule = response.data.rfqcapsule || null;
                const rfqPackagingParts = response.data.rfqpackagingparts || [];
                const servingUnits_data = response.data.servingUnits || [];
                const sfpImages = response.data.presignedSfp || [];
                const notes = response.data.notes || [];



                if (rfq) {
                    // Check if RFQ status is greater than 5
                    const rfqStatus = rfq.RfqStatus || rfq.rfqStatus || rfq.status || 0;

                    if (rfqStatus > 5) {
                        // console.log('RFQ status is greater than 5, not available for formula creation');
                        toast.error('This RFQ is not available for formula creation (status > 5)');
                        this.setState({ loadingRfqs: false });
                        // Load regular available RFQs instead
                        this.loadAvailableRfqs();
                        return;
                    }
                    // Transform single RFQ data with all available fields
                    // Extract fields based on the JSON structure provided
                    const extractedRfqId = rfq.RfqId || rfqId; // RfqId from JSON structure
                    const company = rfq.Company || ''; // Company from JSON
                    const product = rfq.ProductName || ''; // ProductName from JSON

 

                    const transformedRfq = {
                        id: extractedRfqId,
                        rfqNumber: `RFQ-${String(extractedRfqId).padStart(4, '0')}`,
                        company: company,
                        product: product,
                        formula: rfq.Formula || '',
                        form: rfq.Form || 'capsule',
                        servingSize: rfq.ServingSize || '',
                        servingUnit: rfq.ServingUnit || '',
                        rfqStatus: rfqStatus,
                        // Sales Rep and Order Information
                        salesRep: rfq.SalesRep || '',
                        assignedTo: rfq.AssignedTo || '',
                        orderType: rfq.OrderType || '',
                        itemNumber: rfq.ItemNumber || '',
                        sharepointLink: rfq.SharepointLink || '',
                        // Contact information from JSON
                        contact: rfq.Contact || '',
                        phone: rfq.Phone || '',
                        address: rfq.Address || '',
                        // Packaging details from JSON
                        packagingType: rfq.PackagingType || '',
                        packagingCsm: rfq.PackagingCsm === 1 || rfq.PackagingCsm === true,
                        bottleType: rfq.BottleType || '',
                        bottleColor: rfq.BottleColor || '',
                        closureType: rfq.ClosureType || '',
                        closureColor: rfq.ClosureColor || '',
                        capLinerType: rfq.CapLinerType || '',
                        labelType: rfq.LabelType || '',
                        // Boolean flags from JSON
                        cotton: rfq.Cotton || false,
                        desiccant: rfq.Desiccant || false,
                        neckShrink: rfq.NeckShrink || false,
                        productBox: rfq.ProductBox || false,
                        productInsert: rfq.ProductInsert || false,
                        closureSticker: rfq.ClosureSticker || false,
                        masterCase: rfq.MasterCase || false,
                        testingRequired: rfq.TestingRequired || false,
                        allergenFree: rfq.AllergenFree || false,
                        certifiedOrganic: rfq.CertifiedOrganic || false,
                        kitting: rfq.Kitting || false,
                        // Additional fields
                        additionalInformationNotes: rfq.AdditionalInformationNotes || '',
                        shippingMethod: rfq.ShippingMethod || '',
                        paymentTerms: rfq.PaymentTerms || '',
                        isArchived: rfq.IsArchived || false,
                        createdDateTime: rfq.CreatedDateTime || '',
                        updatedDateTime: rfq.UpdatedDateTime || '',
                        // Form-specific fields
                        // Capsule details
                        capsuleSize: rfq.CapsuleSize || '0',
                        capsuleSpecifications: rfq.CapsuleSpecifications || '',
                        capsuleWeight: rfq.CapsuleWeight || '',
                        capsuleColor: rfq.CapsuleColor || '',
                        capsuleFillWeight: rfq.CapsuleFillWeight || '',
                        capsuleRange: rfq.CapsuleRange || '',
                        capsuleTotalWeight: rfq.CapsuleTotalWeight || '',
                        // Tablet details
                        tabletWeight: rfq.TabletWeight || '',
                        tabletShape: rfq.TabletShape || '',
                        // Liquid details
                        liquidDensity: rfq.LiquidDensity || '',
                        // Store ingredients and related data
                        ingredients: ingredients,
                        testing: testing,
                        tiers: tiers
                    };

                    // Transform RFQ ingredient parts to frontend format
                    const transformedIngredientParts = rfqIngredientParts.map(ingredient => {

                        return {
                            RfqIngredientPartId: ingredient.RfqIngredientPartId,
                            RfqId: ingredient.RfqId,
                            PartID: ingredient.PartID,
                            PartName: ingredient.PartName,
                            Amount: ingredient.Amount,
                            Overage: ingredient.Overage,
                            RawsId: ingredient.RawsId,
                            AmountPerServing: ingredient.AmountPerServing,
                            Unit: ingredient.Unit,
                            Source: ingredient.Source,
                            Type: ingredient.Type,
                            OverageCost: ingredient.OverageCost,
                            IsCsm: ingredient.IsCsm,
                            ActiveInactiveOption: ingredient.ActiveInactiveOption,
                            SelectedLimit: ingredient.SelectedLimit,
                            filteredParts: []
                        };
                    });

                    // Transform RFQ capsule to frontend format (single record)
                    const transformedCapsule = rfqCapsule ? {
                        RfqCapsuleId: rfqCapsule.RfqCapsuleId || 0,
                        RfqId: rfqCapsule.RfqId || 0,
                        RawsId: rfqCapsule.RawsId || 0,
                        PartID: rfqCapsule.PartID || '',
                        PartName: rfqCapsule.PartName || '',
                        filteredParts: []
                    } : this.state.capsule;

                    // Transform RFQ packaging parts to frontend format
                    const transformedPackagingParts = rfqPackagingParts.map(part => ({
                        RfqPackagingPartId: part.RfqPackagingPartId,
                        RfqId: part.RfqId,
                        RawsId: part.RawsId,
                        PartID: part.PartID,
                        PartName: part.PartName,
                        Amount: part.Amount,
                        OverageCost: part.OverageCost,
                        IsCsm: part.IsCsm,
                        RfqServingUnitId: part.RfqServingUnitId || 0,
                        filteredParts: [] // Will be populated when parts are loaded
                    }));

                    // Get serving units from RFQ
                    const servingUnits = servingUnits_data || [];

                    // Transform notes to frontend format
                    const transformedNotes = notes.map(note => ({
                        RfqNoteId: note.RfqNoteId || 0,
                        RfqId: note.RfqId || 0,
                        NoteText: note.NoteText || '',
                        UserId: note.UserId || 0,
                        Username: note.Username || 'Unknown',
                        CreatedDateTime: note.CreatedDateTime,
                        Replies: note.Replies ? note.Replies.map(reply => ({
                            RfqNoteReplyId: reply.RfqNoteReplyId || 0,
                            RfqNoteId: reply.RfqNoteId || 0,
                            NoteText: reply.NoteText || '',
                            UserId: reply.UserId || 0,
                            CreatedDateTime: reply.CreatedDateTime,
                            Username: reply.Username || ''
                        })) : []
                    }));

                    // Transform testing requirements to testingItems
                    const testingItems = [];
                    const testingMap = {}; // Deduplicate by TestName

                    // Add all testing requirements from testing array (including Micro, Heavy Metal, Assay)
                    // Deduplicate by TestName since each test has multiple records (one per serving unit)
                    // Store all RfqTestingIds for proper updates
                    testing.forEach(test => {
                        if (test.TestName && test.TestName.trim() !== '') {
                            const isStandard = ['Micro', 'Heavy Metal', 'Assay'].includes(test.TestName);

                            if (!testingMap[test.TestName]) {
                                testingMap[test.TestName] = {
                                    testingType: test.TestName,
                                    cost: test.Cost || '',
                                    numberOfIngredients: test.NumberOfIngredients || 0,
                                    RfqTestingIds: [test.RfqTestingId], // Store all IDs as array
                                    RfqId: test.RfqId || 0,
                                    isStandard: isStandard
                                };
                            } else {
                                // Add additional IDs for the same test name
                                testingMap[test.TestName].RfqTestingIds.push(test.RfqTestingId);
                            }
                        }
                    });

                    // Convert map to array
                    Object.values(testingMap).forEach(item => testingItems.push(item));

                    // Set as available RFQs (single item array) and auto-select
                    this.setState({
                        availableRfqs: [transformedRfq],
                        loadingRfqs: false,
                        sfpImages: sfpImages,
                        notesList: transformedNotes,
                        testingItems: testingItems,
                        servingUnits: servingUnits,
                        // Pre-populate ingredient and packaging parts if they exist
                        ingredientParts: transformedIngredientParts.length > 0 ?
                            this.calculateAmountsForAllParts(transformedIngredientParts) : this.state.ingredientParts,
                        capsule: transformedCapsule,
                        packagingParts: transformedPackagingParts.length > 0 ? transformedPackagingParts : this.state.packagingParts
                    }, () => {
                        // Auto-select this RFQ
                        this.selectRfq(transformedRfq);
                        // Update fill weight if ingredient parts were loaded
                        if (transformedIngredientParts.length > 0) {
                            this.forceFillWeightUpdate();
                        }
                        // Initialize searchable dropdowns with the loaded parts data
                        this.initializeAllSearchableDropdowns();
                    });
                } else {
                    console.error('RFQ data not found');
                    this.setState({ loadingRfqs: false });
                }
            })
            .catch(error => {
                console.error('Error loading specific RFQ:', error);
                console.error('Error details:', error.response);
                this.setState({ loadingRfqs: false });
                // Fallback to loading available RFQs
                this.loadAvailableRfqs();
            });
    }

    // Load specific RFQ data when selected from dropdown (includes ingredient parts)
    loadSpecificRfqForSelection = (rfqId) => {
        this.setState({ loadingRfqs: true });
        this.loadRfq(rfqId);
    }

    loadSpecificRfq = (rfqId) => {
        this.setState({ loadingRfqs: true });
        this.loadRfq(rfqId);
    }

    lookupFormula = async () => {
        const { formulaLookupInput } = this.state;
        if (!formulaLookupInput.trim()) return;

        // Normalize input: accept "6", "0006", "FORM-0006", etc.
        let lookupId = formulaLookupInput.trim().toUpperCase();
        if (!lookupId.startsWith('FORM-')) {
            lookupId = `FORM-${lookupId.padStart(4, '0')}`;
        }

        this.setState({ formulaLookupLoading: true, formulaLookupError: '' });

        try {
            const response = await axios.get(`/api/formulas/${lookupId}`);
            if (response.data.success && response.data.data) {
                const data = response.data.data;
                // Load the RFQ for this formula
                this.loadSpecificRfqForSelection(data.rfq_id);
                toast.success(`Loaded formula ${lookupId}`);
                this.setState({ formulaLookupLoading: false, formulaLookupInput: '' });
            }
        } catch (error) {
            if (error.response?.status === 404) {
                this.setState({
                    formulaLookupError: `Formula ${lookupId} not found. Please verify the number.`,
                    formulaLookupLoading: false
                });
            } else {
                this.setState({
                    formulaLookupError: 'Error loading formula. Please try again.',
                    formulaLookupLoading: false
                });
            }
        }
    }

    generateFormulaNumber = () => {
        // Generate formula number in format FORM-XXXX
        const timestamp = Date.now().toString().slice(-4);
        const formulaNumber = `FORM-${timestamp}`;
        this.setState({ formulaNumber });
    }

    loadAvailableRfqs = () => {
        this.setState({ loadingRfqs: true });

        // Fetch RFQs with status 3 (Submitted to Formulation)
        axios.get('/rfq/list?status_filter=Submitted to Formulation')
            .then(response => {
                const rfqs = response.data.rfqs || [];

                // Filter out RFQs with status > 5 and transform RFQ data for dropdown
                const transformedRfqs = rfqs
                    .filter(rfq => rfq.RfqStatus <= 5) // Only include RFQs with status 5 or less
                    .map(rfq => ({
                    id: rfq.RfqId,
                    rfqNumber: `RFQ-${String(rfq.RfqId).padStart(4, '0')}`,
                    company: rfq.Company || rfq.company || rfq.CompanyName || rfq.companyName || '',
                    product: rfq.ProductName || rfq.productName || rfq.Product || rfq.product || '',
                    formula: rfq.Formula || '',
                    form: rfq.Form || 'capsule',
                    servingSize: rfq.ServingSize || '',
                    servingUnit: rfq.ServingUnit || rfq.ServingsPerUnit || '',
                    rfqStatus: rfq.RfqStatus || 0,
                    // Additional RFQ fields
                    projectName: rfq.ProjectName || '',
                    bottleCount: rfq.BottleCount || '',
                    flavor: rfq.Flavor || '',
                    bottleSize: rfq.BottleSize || '',
                    unitCount: rfq.UnitCount || '',
                    unitCost: rfq.UnitCost || '',
                    monthsSupply: rfq.MonthsSupply || '',
                    // Capsule details
                    capsuleSize: rfq.CapsuleSize || '0',
                    capsuleSpecifications: rfq.CapsuleSpecifications || '',
                    capsuleWeight: rfq.CapsuleWeight || '',
                    capsuleColor: rfq.CapsuleColor || '',
                    capsuleFillWeight: rfq.CapsuleFillWeight || '',
                    capsuleRange: rfq.CapsuleRange || '',
                    capsuleTotalWeight: rfq.CapsuleTotalWeight || '',
                    // Tablet details
                    tabletWeight: rfq.TabletWeight || '',
                    tabletShape: rfq.TabletShape || '',
                    // Liquid details
                    liquidDensity: rfq.LiquidDensity || '',
                    // Powder details
                    powderServingSize: rfq.PowderServingSize || '',
                    // Gummy details
                    gummyFlavor: rfq.GummyFlavor || '',
                    gummyColor: rfq.GummyColor || '',
                    gummyShape: rfq.GummyShape || ''
                }));

                this.setState({
                    availableRfqs: transformedRfqs,
                    loadingRfqs: false
                });
            })
            .catch(error => {
                console.error('Error loading RFQs:', error);
                this.setState({
                    availableRfqs: [],
                    loadingRfqs: false
                });
            });
    }

    // Capsule size to weight mapping
    capsuleSizeWeights = {
        "4": 0.038,
        "3": 0.048,
        "2": 0.061,
        "1": 0.076,
        "0": 0.1,
        "0E": 0.107,
        "00": 0.12,
        "00E": 0.14,
        "000": 0.16
    };

    // Handle new ingredient part fields
    handleNewIngredientPartChange = (field, value) => {
        this.setState({
            [field]: value
        });
    }


    handleInputChange = (field, value) => {
        this.setState({ [field]: value }, () => {
            // Calculate Total Weight when Capsule Weight or Fill Weight changes
            if (field === 'capsuleWeight' || field === 'capsuleFillWeight') {
                this.calculateTotalWeight();
            }

            // Initialize capsule weight when form is changed to capsule
            if (field === 'form' && value === 'capsule') {
                setTimeout(() => {
                    this.initializeCapsuleWeight();
                }, 100);
            }

            // Recalculate calculator modal values when serving size changes
            if (field === 'servingSize') {
                this.recalculateCalculatorData();
            }
        });
    }

    calculateTotalWeight = () => {
        const { capsuleWeight, capsuleFillWeight } = this.state;
        const capsuleWeightNum = parseFloat(capsuleWeight) || 0;
        const fillWeightNum = parseFloat(capsuleFillWeight) || 0;
        const totalWeight = capsuleWeightNum + fillWeightNum;

        // Only update if we have valid numbers
        if (capsuleWeightNum > 0 || fillWeightNum > 0) {
            this.setState({ capsuleTotalWeight: totalWeight.toFixed(3) });
        } else {
            this.setState({ capsuleTotalWeight: '' });
        }
    }

    // Initialize capsule weight when RFQ is selected if form is capsule and size is set
    initializeCapsuleWeight = () => {
        const { form, capsuleSize, capsuleWeight } = this.state;

        // Only initialize if form is capsule, capsule size is set, and capsule weight is empty
        if (form === 'capsule' && capsuleSize && (!capsuleWeight || capsuleWeight === '') && this.capsuleSizeWeights[capsuleSize]) {
            const weightValue = this.capsuleSizeWeights[capsuleSize];
            this.setState({ capsuleWeight: weightValue }, () => {
                // Calculate total weight after capsule weight is updated
                this.calculateTotalWeight();
            });
        }
    }

    handleCapsuleSizeChange = (size) => {
        // Update capsule size
        this.setState({ capsuleSize: size });

        // Auto-populate capsule weight based on size
        if (size && this.capsuleSizeWeights[size]) {
            this.setState({ capsuleWeight: this.capsuleSizeWeights[size] }, () => {
                // Calculate total weight after capsule weight is updated
                this.calculateTotalWeight();
            });
        } else {
            // Clear capsule weight if no size selected or invalid size
            this.setState({ capsuleWeight: '' }, () => {
                // Calculate total weight after capsule weight is cleared
                this.calculateTotalWeight();
            });
        }
    }


    // Calculate fill weight from ingredient parts
    calculateFillWeight = () => {
        const { ingredientParts } = this.state;

        let totalWeightInGrams = 0;

        ingredientParts.forEach((part, index) => {
            if (part.AmountPerServing && !isNaN(part.AmountPerServing)) {
                const amountInGrams = parseFloat(part.AmountPerServing);
                totalWeightInGrams += amountInGrams;
            } 
        });

        return parseFloat(totalWeightInGrams.toFixed(3));
        //return totalWeightInGrams;
    }

    // Update fill weight whenever ingredient parts change
    updateFillWeight = () => {

        // Only calculate fill weight if we have ingredient parts and form is capsule
        if (this.state.form === 'capsule' && this.state.ingredientParts && this.state.ingredientParts.length > 0) {
            const fillWeight = this.calculateFillWeight();
            // console.log('Calculated fill weight:', fillWeight);
            this.setState({ capsuleFillWeight: fillWeight }, () => {
                // Calculate total weight when fill weight is updated
                this.calculateTotalWeight();
            });
        } else {
            // console.log('Fill weight calculation skipped - conditions not met');
        }
    }

    // Check if ready for fill weight calculation and update if needed
    checkAndUpdateFillWeight = () => {
        // Add a longer delay to ensure all state updates are complete
        setTimeout(() => {
            if (this.state.form === 'capsule' && this.state.ingredientParts && this.state.ingredientParts.length > 0) {
                // Check if any ingredient parts have data
                const hasIngredientData = this.state.ingredientParts.some(part =>
                    (part.Amount && !isNaN(part.Amount))
                );

                if (hasIngredientData) {
                    this.updateFillWeight();
                }
            }
        }, 200);
    }

    // Force fill weight calculation regardless of conditions (for immediate triggers)
    forceFillWeightUpdate = () => {
        setTimeout(() => {
            this.updateFillWeight();
        }, 100);
    }

    // Check if the component already has an RFQ selected and ingredient parts loaded
    checkIfNeedsFillWeightCalculation = () => {
        // Only proceed if not loading and we have necessary data
        if (!this.state.loadingRfqs && !this.state.loadingParts) {
            if (this.state.selectedRfq && this.state.form === 'capsule' &&
                this.state.ingredientParts && this.state.ingredientParts.length > 0) {

                // Check if any ingredient parts have data
                const hasIngredientData = this.state.ingredientParts.some(part =>
                    (part.amount && !isNaN(part.amount))
                );

                if (hasIngredientData) {
                    this.forceFillWeightUpdate();
                }
            }
        }
    }

    // Check if calculator should be shown for an ingredient part
    shouldShowCalculator = (parts) => {

        let partId = parts.PartID;

        if (!partId) {
            return false;
        }

        // Find the part in originalIngredientParts to get Active1/Active2 values
        const partData = this.state.originalIngredientParts.find(part => part.id === partId);

        if (!partData) {
            return false;
        }



        // Show calculator if Active1 or Active2 has a value (not null, undefined, or empty)
        const hasActiveInactive = partData.ActiveInactive && (typeof partData.ActiveInactive === 'string' ? partData.ActiveInactive.trim() !== '' : true);


        return hasActiveInactive;
    }

    selectRfq = (rfq) => {
        // Generate formula ID based on RFQ number for formulaNumber (Formula ID field)
        const formulaId = rfq.rfqNumber.replace('RFQ-', 'FORM-');

        // Always populate with RFQ data if available, use defaults only if empty
        let formSpecificState = {};

        // Populate form-specific fields based on form type
        if (rfq.form === 'capsule') {
            formSpecificState = {
                capsuleSize: rfq.capsuleSize || '0',
                capsuleSpecifications: rfq.capsuleSpecifications || '',
                capsuleWeight: rfq.capsuleWeight || '',
                capsuleColor: rfq.capsuleColor || '',
                // Don't set capsuleFillWeight from RFQ - it will be calculated from ingredient parts
                capsuleRange: rfq.capsuleRange || '',
                capsuleTotalWeight: rfq.capsuleTotalWeight || ''
            };
        } else if (rfq.form === 'tablet') {
            formSpecificState = {
                tabletWeight: rfq.tabletWeight || '',
                tabletShape: rfq.tabletShape || ''
            };
        } else if (rfq.form === 'liquid') {
            formSpecificState = {
                liquidDensity: rfq.liquidDensity || ''
            };
        }

        // Always populate all form fields if they exist in the RFQ data
        // This allows switching between forms while preserving data
        const allFormFields = {
            // Capsule fields
            capsuleSize: rfq.capsuleSize || '0',
            capsuleSpecifications: rfq.capsuleSpecifications || '',
            capsuleWeight: rfq.capsuleWeight || '',
            capsuleColor: rfq.capsuleColor || '',
            // Don't set capsuleFillWeight from RFQ - it will be calculated from ingredient parts
            capsuleRange: rfq.capsuleRange || '',
            capsuleTotalWeight: rfq.capsuleTotalWeight || '',
            // Tablet fields
            tabletWeight: rfq.tabletWeight || '',
            tabletShape: rfq.tabletShape || '',
            // Liquid fields
            liquidDensity: rfq.liquidDensity || ''
        };

        // Merge form-specific state with all form fields
        formSpecificState = { ...allFormFields, ...formSpecificState };


        this.setState({
            selectedRfq: rfq,
            formulaNumber: formulaId,  // Formula ID field (FORM-XXXX)
            company: rfq.company || '',
            formulaName: rfq.formula || '',  // Formula Number field - from API Formula column
            productName: rfq.product || '',
            form: rfq.form || 'Select form',
            servingSize: rfq.servingSize || '',
            servingsPerUnit: rfq.servingUnit || '',
            salesRep: rfq.salesRep || '',
            assignedTo: rfq.assignedTo || '',
            orderType: rfq.orderType || '',
            itemNumber: rfq.itemNumber || '',
            sharepointLink: rfq.sharepointLink || '',
            ...formSpecificState
        }, () => {
            // Initialize capsule weight if form is capsule and no weight is set
            if (this.state.form === 'capsule' && this.state.capsuleSize && !this.state.capsuleWeight) {
                this.initializeCapsuleWeight();
            }
            // Calculate fill weight from ingredient parts after RFQ selection
            this.forceFillWeightUpdate();
        });
    }

    clearRfqSelection = () => {
        this.setState({
            selectedRfq: null,
            formulaNumber: '', // Keep empty when no RFQ is selected
            company: '',
            formulaName: '',
            productName: '',
            form: 'Select form',
            servingSize: '',
            servingsPerUnit: '',
            salesRep: '',
            assignedTo: '',
            orderType: '',
            itemNumber: '',
            // Clear capsule details
            capsuleSize: '0',
            capsuleSpecifications: '',
            capsuleWeight: '',
            capsuleColor: '',
            capsuleFillWeight: '',
            capsuleRange: '',
            capsuleTotalWeight: '',
            // Clear tablet details
            tabletWeight: '',
            tabletShape: '',
            // Clear liquid details
            liquidDensity: ''
        });
    }

    handleSaveDraft = () => {
        this.saveFormula('r&d', true);
    }

    handleUpdate = () => {
        this.saveFormula('purch-review');
    }

    validateForm = () => {
        const errors = {};
        const { selectedRfq, company, productName, form, servingSize, servingsPerUnit } = this.state;

        if (!selectedRfq) errors.rfq = 'Please select an RFQ to link to this formula';
        if (!company) errors.company = 'Company is required';
        if (!productName) errors.productName = 'Product name is required';
        if (!form || form === 'Select form') errors.form = 'Form is required';
        if (!servingSize) errors.servingSize = 'Serving size is required';
        // Check if servingsPerUnit is filled OR if servingUnits from RFQ exist
        const hasServingUnits = this.state.servingUnits && this.state.servingUnits.length > 0;
        if (!servingsPerUnit && !hasServingUnits) errors.servingsPerUnit = 'Servings/Unit is required';

        return errors;
    }

    saveFormula = (status, isDraft = false) => {
        const {
            selectedRfq, company, formulaNumber, formulaName, productName, form, servingSize, servingsPerUnit,
            capsuleSize, capsuleSpecifications, capsuleWeight, capsuleColor, capsuleFillWeight, capsuleRange, capsuleTotalWeight,
            tabletWeight, tabletShape, liquidDensity, ingredientParts, packagingParts, newIngredientPartId, newIngredientPartName
        } = this.state;

        // Validation
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            toast.error('Please fill in all required fields');
            return;
        }

        // No separate formula data - we'll just update the RFQ record

        // Determine RFQ status based on formula action
        const rfqStatus = status === 'r&d' ? 2 : 3; // 4 for Draft, 5 for In-Process

        // Prepare RFQ update data with all required fields
        // Use servingUnits from RFQ if available, otherwise use servingsPerUnit
        const servingUnitValue = (this.state.servingUnits && this.state.servingUnits.length > 0)
            ? this.state.servingUnits[0].ServingUnit  // Use first serving unit for legacy ServingUnit field
            : servingsPerUnit;

        let rfqUpdateData = {
            RfqStatus: rfqStatus,
            Company: company,
            Formula: formulaName,
            Form: form !== 'Select form' ? form : 'capsule',
            ProductName: productName,
            ServingSize: servingSize,
            ServingUnit: servingUnitValue,
            AssignedTo: this.state.assignedTo || null
        };

        // Add form-specific fields based on the selected form
        if (form === 'capsule') {
            rfqUpdateData = {
                ...rfqUpdateData,
                CapsuleSize: capsuleSize || null,
                CapsuleSpecifications: capsuleSpecifications || null,
                CapsuleWeight: capsuleWeight || null,
                CapsuleColor: capsuleColor || null,
                CapsuleFillWeight: capsuleFillWeight || null,
                CapsuleRange: capsuleRange || null,
                CapsuleTotalWeight: capsuleTotalWeight || null
            };
        } else if (form === 'tablet') {
            rfqUpdateData = {
                ...rfqUpdateData,
                TabletWeight: tabletWeight || null,
                TabletShape: tabletShape || null
            };
        } else if (form === 'liquid') {
            rfqUpdateData = {
                ...rfqUpdateData,
                LiquidDensity: liquidDensity || null
            };
        }

        // Prepare ingredient parts data for rfqingredientparts table
        const ingredientPartsData = ingredientParts
            .filter(part => part.PartID && part.PartName) // Only include parts with data
            .map(part => ({
                RfqIngredientPartId: part.RfqIngredientPartId,
                RfqId: selectedRfq.id,
                PartID: part.PartID,
                PartName: part.PartName,
                Amount: part.Amount,  // Label Claim goes to Amount
                Overage: part.Overage || 100,
                RawsId: part.RawsId,
                AmountPerServing: part.AmountPerServing,  // Amount (g) goes to AmountPerServing
                Unit: part.Unit,
                Source: part.Source,
                Type: part.Type,
                OverageCost: part.OverageCost,
                IsCsm: part.IsCsm,
                ActiveInactiveOption: part.ActiveInactiveOption,
                SelectedLimit: part.SelectedLimit,
                deleted: part.deleted
            }));



        const packagingPartsData = packagingParts
            .filter(part => {
                return part.PartID; // Only require partId, partName can be empty
            }) // Only include parts with data
            .map(part => {

                return {
                    RfqPackagingPartId: part.RfqPackagingPartId,
                    RawsId: part.RawsId,
                    RfqId: selectedRfq.id,
                    PartID: part.PartID,
                    PartName: part.PartName,
                    Amount: parseFloat(part.Amount) || 0,
                    OverageCost: part.OverageCost || 100,
                    IsCsm: part.IsCsm || 0,
                    RfqServingUnitId: part.RfqServingUnitId || 0,
                    deleted: part.deleted
                };
            });

        // Prepare capsule data (single record)
        const capsuleData = this.state.capsule && this.state.capsule.PartID ? {
            RfqCapsuleId: this.state.capsule.RfqCapsuleId || 0,
            RfqId: selectedRfq.id,
            RawsId: this.state.capsule.RawsId || 0,
            PartID: this.state.capsule.PartID,
            PartName: this.state.capsule.PartName
        } : null;

        // Prepare notes data
        const notesData = [];
        this.state.notesList.forEach((note) => {
            if (note && note.NoteText && note.NoteText.trim() !== '') {
                notesData.push({
                    NoteText: note.NoteText.trim(),
                    RfqId: note.RfqId || 0,
                    RfqNoteId: note.RfqNoteId || 0,
                    UserId: note.UserId || 0
                });
            }
        });

        // Prepare testing data - create one record for each serving unit
        const testingData = [];
        const activeServingUnits = this.state.servingUnits.filter(unit => unit.RfqServingUnitId > 0);

        this.state.testingItems.forEach((item) => {
            if (item && item.testingType && item.testingType.trim() !== '') {
                if (item.deleted) {
                    // If deleted, send one record with deleted flag
                    // Backend will delete all records with this TestName
                    testingData.push({
                        RfqTestingId: 0,
                        RfqId: selectedRfq ? selectedRfq.id : 0,
                        TestName: item.testingType.trim(),
                        deleted: 1
                    });
                } else {
                    // If we have existing IDs, update them; otherwise create new ones
                    const existingIds = item.RfqTestingIds || [];

                    activeServingUnits.forEach((servingUnit, index) => {
                        testingData.push({
                            RfqTestingId: existingIds[index] || 0, // Use existing ID if available
                            RfqId: selectedRfq ? selectedRfq.id : 0,
                            TestName: item.testingType.trim(),
                            Cost: parseFloat(item.cost) || null,
                            NumberOfIngredients: parseInt(item.numberOfIngredients) || null,
                            RfqServingUnitId: servingUnit.RfqServingUnitId
                        });
                    });
                }
            }
        });

        if (isDraft) {
            this.setState({ savingDraft: true });
        } else {
            this.setState({ loading: true });
        }

        // Create all API promises - starting with RFQ update (this IS the formula)
        const apiPromises = [];

        // Update RFQ record (this is the formula) if RFQ is selected
        if (selectedRfq) {
            // Prepare data in the format expected by /rfq/save endpoint
            const savePayload = {
                rfq: rfqUpdateData,
                notes: notesData,
                testing: testingData,
                ingredients: [],
                tiers: [],
                packagingParts: []
            };

            apiPromises.push(axios({
                method: 'post',
                url: `/rfq/save?rfq_id=${selectedRfq.id}`,
                data: savePayload,
                headers: {
                    'Content-Type': 'application/json'
                }
            }));
        } else {
            // If no RFQ selected, we can't proceed
            toast.error('Please select an RFQ to create the formula');
            if (isDraft) {
                this.setState({ savingDraft: false });
            } else {
                this.setState({ loading: false });
            }
            return;
        }

        // Add ingredient parts sync promise if there are ingredient parts
        if (selectedRfq && ingredientPartsData.length > 0) {
            apiPromises.push(
                axios({
                    method: 'post',
                    url: '/api/rfq-ingredient-parts',
                    data: {
                        rfqId: selectedRfq.id,
                        parts: ingredientPartsData
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            );
        }


        if (selectedRfq && capsuleData) {
            console.log('Sending capsule data:', {
                rfqId: selectedRfq.id,
                capsule: capsuleData
            });

            apiPromises.push(
                axios({
                    method: 'post',
                    url: '/api/rfq-capsule',
                    data: {
                        rfqId: selectedRfq.id,
                        capsule: capsuleData
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            );
        }

        if (selectedRfq && packagingPartsData.length > 0) {
            console.log('Sending packaging parts data:', {
                rfqId: selectedRfq.id,
                parts: packagingPartsData
            });

            apiPromises.push(
                axios({
                    method: 'post',
                    url: '/api/rfq-packaging-parts',
                    data: {
                        rfqId: selectedRfq.id,
                        parts: packagingPartsData
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            );
        }

        // Execute all API calls
        Promise.all(apiPromises)
            .then(responses => {
                // console.log('API responses:', responses);

                // The first response is always the RFQ update
                const rfqResponse = responses[0];

                // Find the ingredient parts and packaging parts responses
                let ingredientPartsResponse = null;
                let packagingPartsResponse = null;

                // Check each response to identify which is which
                for (let i = 1; i < responses.length; i++) {
                    const response = responses[i];
                    if (response && response.config && response.config.url) {
                        if (response.config.url.includes('rfq-ingredient-parts')) {
                            ingredientPartsResponse = response;
                        } else if (response.config.url.includes('rfq-packaging-parts')) {
                            packagingPartsResponse = response;
                        }
                    }
                }

                // Check if RFQ was saved successfully (response contains RfqId)
                if (rfqResponse && (rfqResponse.data.RfqId || rfqResponse.data.success)) {
                    const actionText = status === 'r&d' ? 'saved to R&D' : 'submitted to Estimate';
                    toast.success(`Formula ${actionText} successfully!`);

                    // Clear the new ingredient part fields after successful save
                    this.setState({
                        newIngredientPartId: '',
                        newIngredientPartName: ''
                    });

                    // Check for any failures in parts updates
                    if (ingredientPartsResponse && !ingredientPartsResponse.data.success) {
                        console.warn('Formula saved but ingredient parts sync failed');
                    }

                    if (packagingPartsResponse && !packagingPartsResponse.data.success) {
                        console.warn('Formula saved but packaging parts sync failed');
                    }

                    // Redirect based on status after a short delay
                    setTimeout(() => {
                        if (status === 'purch-review') {
                            window.location.href = `/draft-estimate`;
                        } else {
                            window.location.href = `/formula`;
                        }
                    }, 1500);
                } else {
                    toast.error('Failed to save formula (RFQ update failed)');
                }
            })
            .catch(error => {
                console.error('Error saving formula:', error);
                if (error.response?.status === 409) {
                    toast.warn('This formula has already been submitted to Estimate.');
                    setTimeout(() => { window.location.href = '/draft-estimate'; }, 1500);
                } else {
                    toast.error('Error saving formula');
                }
            })
            .finally(() => {
                if (isDraft) {
                    this.setState({ savingDraft: false });
                } else {
                    this.setState({ loading: false });
                }
            });
    }

    saveNoteToDatabase = async (noteText) => {
        try {
            const selectedRfq = this.state.selectedRfq;
            if (!selectedRfq || !selectedRfq.id) {
                toast.error('No RFQ selected');
                return false;
            }

            // Prepare note data
            const noteData = {
                notes: [{
                    RfqNoteId: 0,
                    RfqId: selectedRfq.id,
                    NoteText: noteText
                }]
            };

            // Save note to database
            await axios.post(`/rfq/save?rfq_id=${selectedRfq.id}`, noteData);

            toast.success('Note added successfully!');
            return true;
        } catch (error) {
            console.error('Error saving note:', error);
            toast.error('Failed to save note');
            return false;
        }
    }

    loadNotesFromDatabase = async () => {
        try {
            const selectedRfq = this.state.selectedRfq;
            if (!selectedRfq || !selectedRfq.id) {
                return;
            }

            const response = await axios.get(`/rfq/${selectedRfq.id}`);
            const responseData = response.data;

            // Map notes data to form format
            let notesList = [];
            if (responseData.notes && responseData.notes.length > 0) {
                notesList = responseData.notes.map(note => ({
                    RfqNoteId: note.RfqNoteId || 0,
                    RfqId: note.RfqId || 0,
                    NoteText: note.NoteText || '',
                    UserId: note.UserId || 0,
                    CreatedDateTime: note.CreatedDateTime,
                    Username: note.Username || '',
                    Replies: note.Replies ? note.Replies.map(reply => ({
                        RfqNoteReplyId: reply.RfqNoteReplyId || 0,
                        RfqNoteId: reply.RfqNoteId || 0,
                        NoteText: reply.NoteText || '',
                        UserId: reply.UserId || 0,
                        CreatedDateTime: reply.CreatedDateTime,
                        Username: reply.Username || ''
                    })) : []
                }));
            }

            console.log('AddNewFormula - Setting notesList in state:', notesList);
            this.setState({
                notesList: notesList
            }, () => {
                console.log('AddNewFormula - Notes state updated, new state:', this.state.notesList);
            });
        } catch (error) {
            console.error('Error loading notes:', error);
        }
    }

    saveReplyToDatabase = async (parentNote, replyText) => {
        try {
            const selectedRfq = this.state.selectedRfq;
            if (!selectedRfq || !selectedRfq.id) {
                return false;
            }

            // Prepare reply data
            const replyData = {
                RfqNoteId: parentNote.RfqNoteId,
                RfqId: selectedRfq.id,
                NoteText: replyText,
                ParentUserId: parentNote.UserId
            };

            console.log('Sending reply data:', replyData);

            // Save reply to database
            const response = await axios.post(`/rfq/notes/reply`, replyData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log('Reply response:', response.data);

            toast.success('Reply added successfully!');
            return true;
        } catch (error) {
            console.error('Error saving reply:', error);
            console.error('Error response:', error.response?.data);
            toast.error('Failed to save reply');
            return false;
        }
    }

    // Load all parts from API
    loadAllParts = () => {
        this.setState({ loadingParts: true });

        // Get all parts for packaging
        const dataObj = {
            search: "",
            page: 1,
            perPage: 10000
        };

        // Load all three datasets
        Promise.all([
            axios.put('raws/get-raws-by-ingredient'),
            axios.put('raws/get-raws-by-packaging')
        ])
            .then(responses => {
                const ingredientPartsResponse = responses[0];
                const packagingPartsResponse = responses[1];

                const ingredientParts = ingredientPartsResponse.data.records || [];
                const packagingParts = packagingPartsResponse.data.records || [];

                // Transform and deduplicate all parts (for fallback)
                const seenAllIds = new Set();

                // Transform and deduplicate ingredient parts (60000-69999)
                const seenIngredientIds = new Set();
                const transformedIngredientParts = ingredientParts
                    .filter(part => {
                        if (seenIngredientIds.has(part.Id)) {
                            console.warn(`Duplicate ingredient part ID found: ${part.Id}`);
                            return false;
                        }
                        seenIngredientIds.add(part.Id);
                        return true;
                    })
                    .map(part => {
                        return {
                            id: part.Id,
                            name: part.RawMaterialName,
                            rawsId: part.RawsId,
                            active1: part.Active1,
                            active2: part.Active2,
                            limit1: part.Limit1,
                            limit2: part.Limit2,
                            ActiveInactive: part.ActiveInactive
                        };
                    });

                // Transform and deduplicate packaging parts (70000-89999)
                const seenPackagingIds = new Set();
                const transformedPackagingParts = packagingParts
                    .filter(part => {
                        if (seenPackagingIds.has(part.Id)) {
                            console.warn(`Duplicate packaging part ID found: ${part.Id}`);
                            return false;
                        }
                        seenPackagingIds.add(part.Id);
                        return true;
                    })
                    .map(part => ({
                        id: part.Id,
                        name: part.RawMaterialName,
                        rawsId: part.RawsId,
                        active1: part.Active1,
                        active2: part.Active2,
                        limit1: part.Limit1,
                        limit2: part.Limit2,
                        ActiveInactive: part.ActiveInactive
                    }));

                // Initialize filtered parts for existing rows
                const updatedIngredientParts = this.state.ingredientParts.map(part => ({
                    ...part,
                    filteredParts: transformedIngredientParts
                }));

                const updatedCapsule = {
                    ...this.state.capsule,
                    filteredParts: transformedPackagingParts
                };

                const updatedPackagingParts = this.state.packagingParts.map(part => ({
                    ...part,
                    filteredParts: transformedPackagingParts
                }));

                this.setState({
                    originalIngredientParts: transformedIngredientParts,
                    originalPackagingParts: transformedPackagingParts,
                    filteredIngredientParts: transformedIngredientParts,
                    filteredCapsuleParts: transformedIngredientParts,
                    filteredPackagingParts: transformedPackagingParts,
                    ingredientParts: updatedIngredientParts,
                    capsule: updatedCapsule,
                    packagingParts: updatedPackagingParts,
                    loadingParts: false
                }, () => {
                    // Update fill weight after parts are loaded and ingredient parts are updated
                    this.checkAndUpdateFillWeight();
                    // Also check if we need immediate calculation
                    this.checkIfNeedsFillWeightCalculation();
                });
            })
            .catch(error => {
                console.error('Error loading parts:', error);
                this.setState({
                    originalIngredientParts: [],
                    originalPackagingParts: [],
                    filteredIngredientParts: [],
                    filteredPackagingParts: [],
                    loadingParts: false
                });
            });
    }

    // Filter parts based on Part ID input
    filterPartsByPartId = (partId, type) => {
        // Get the base parts for each type
        let baseParts;
        if (type === 'ingredient') {
            // Use the original ingredient parts from backend (60000-69999)
            baseParts = this.state.originalIngredientParts;
        } else if (type === 'packaging') {
            // Use the original packaging parts from backend (70000-89999)
            baseParts = this.state.originalPackagingParts;
        }

        if (!partId.trim()) {
            if (type === 'ingredient') {
                this.setState({ filteredIngredientParts: baseParts });
            } else if (type === 'packaging') {
                this.setState({ filteredPackagingParts: baseParts });
            }
            return;
        }

        const filtered = baseParts.filter(part =>
            part.id.toLowerCase().includes(partId.toLowerCase())
        );

        if (type === 'ingredient') {
            this.setState({ filteredIngredientParts: filtered });
        } else if (type === 'packaging') {
            this.setState({ filteredPackagingParts: filtered });
        }
    }

    // Handle Part ID change and filter parts for that row only
    handlePartIdChange = (index, value, type) => {
        if (type === 'ingredient') {
            const updatedParts = [...this.state.ingredientParts];

            // Check for duplicate PartID (excluding current row)
            if (value.trim()) {
                const isDuplicate = updatedParts.some((part, idx) =>
                    idx !== index && part.PartID === value
                );

                if (isDuplicate) {
                    toast.error(`Part ID "${value}" is already added. Please select a different part.`);
                    return;
                }
            }

            updatedParts[index].PartID = value;

            // Auto-populate PartName and RawsId if exact match found
            const baseParts = this.state.originalIngredientParts;
            const matchingPart = baseParts.find(part => part.id === value);

            if (matchingPart) {
                updatedParts[index].PartName = matchingPart.name;
                updatedParts[index].RawsId = matchingPart.rawsId || 0;
            } else {
                // Clear part name and RawsId if no exact match
                updatedParts[index].PartName = '';
                updatedParts[index].RawsId = 0;
            }

            // Filter parts for this row only
            if (!value.trim()) {
                updatedParts[index].filteredParts = baseParts;
            } else {
                updatedParts[index].filteredParts = baseParts.filter(part =>
                    part.id.toLowerCase().includes(value.toLowerCase())
                );
            }

            this.setState({ ingredientParts: updatedParts }, () => {
                // Update fill weight when ingredient part changes
                if (matchingPart) {
                    this.checkAndUpdateFillWeight();
                }
            });
        } else if (type === 'packaging') {
            const updatedParts = [...this.state.packagingParts];

            // Check for duplicate PartID (excluding current row)
            if (value.trim()) {
                const isDuplicate = updatedParts.some((part, idx) =>
                    idx !== index && part.PartID === value
                );

                if (isDuplicate) {
                    toast.error(`Part ID "${value}" is already added. Please select a different part.`);
                    return;
                }
            }

            updatedParts[index].PartID = value;

            // Auto-populate PartName if exact match found
            const baseParts = this.state.originalPackagingParts;
            const matchingPart = baseParts.find(part => part.id === value);

            if (matchingPart) {
                updatedParts[index].PartName = matchingPart.name;
                updatedParts[index].RawsId = matchingPart.rawsId || 0;
            } else {
                // Clear part name if no exact match
                updatedParts[index].PartName = '';
                updatedParts[index].RawsId = 0;
            }

            // Filter parts for this row only
            if (!value.trim()) {
                updatedParts[index].filteredParts = baseParts;
            } else {
                updatedParts[index].filteredParts = baseParts.filter(part =>
                    part.id.toLowerCase().includes(value.toLowerCase())
                );
            }

            this.setState({ packagingParts: updatedParts });
        }
    }

    // Handle Part Name selection and auto-populate Part ID
    handlePartNameChange = (index, selectedPartId, type) => {
        let selectedPart = null;

        if (type === 'ingredient') {
            // Look in this row's filtered parts or fall back to original
            const rowParts = this.state.ingredientParts[index].filteredParts || this.state.originalIngredientParts;
            selectedPart = rowParts.find(part => part.id === selectedPartId);

            if (selectedPart) {
                const updatedParts = [...this.state.ingredientParts];
                updatedParts[index].partId = selectedPart.id;
                updatedParts[index].partName = selectedPart.name;

                this.setState({ ingredientParts: updatedParts }, () => {
                    // Update fill weight when ingredient part changes
                    this.checkAndUpdateFillWeight();
                });
            }
        } else if (type === 'packaging') {
            // Look in this row's filtered parts or fall back to original
            const rowParts = this.state.packagingParts[index].filteredParts || this.state.originalPackagingParts;
            console.log('Packaging part selection - selectedPartId:', selectedPartId);
            console.log('Packaging part selection - available rowParts:', rowParts);
            selectedPart = rowParts.find(part => part.id === selectedPartId);
            console.log('Packaging part selection - found selectedPart:', selectedPart);

            if (selectedPart) {
                const updatedParts = [...this.state.packagingParts];
                updatedParts[index].partId = selectedPart.id;
                updatedParts[index].partName = selectedPart.name;
                console.log('Packaging part selection - setting partName to:', selectedPart.name);

                this.setState({ packagingParts: updatedParts });
            } else {
                console.log('Packaging part selection - selectedPart not found!');
            }
        }
    }

    // Simple ingredient search handlers (like AddNewRFQ.js)
    handleIngredientSearch = (searchValue, index) => {
        const filtered = this.state.originalIngredientParts.filter(part =>
            part.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            (part.id && part.id.toString().includes(searchValue))
        );

        const updatedParts = [...this.state.ingredientParts];
        updatedParts[index].PartName = searchValue;

        this.setState({
            ingredientParts: updatedParts,
            filteredIngredients: filtered,
            showIngredientDropdown: true,
            activeDropdownIndex: index
        });
    }

    selectIngredient = (ingredient, index) => {
        const updatedParts = [...this.state.ingredientParts];

        // Check for duplicate PartID (excluding current row)
        const isDuplicate = updatedParts.some((part, idx) =>
            idx !== index && part.PartID === ingredient.id
        );

        if (isDuplicate) {
            toast.error(`Part ID "${ingredient.id}" is already added. Please select a different part.`);
            this.setState({
                showIngredientDropdown: false,
                activeDropdownIndex: null
            });
            return;
        }

        updatedParts[index].PartID = ingredient.id;
        updatedParts[index].PartName = ingredient.name;
        updatedParts[index].RawsId = ingredient.rawsId || 0;

        this.setState({
            ingredientParts: updatedParts,
            showIngredientDropdown: false,
            activeDropdownIndex: null
        }, () => {
            // Update fill weight when ingredient part changes
            this.checkAndUpdateFillWeight();
        });
    }

    handleIngredientInputFocus = (index) => {
        const currentPart = this.state.ingredientParts[index];
        this.setState({
            showIngredientDropdown: true,
            filteredIngredients: this.state.originalIngredientParts,
            activeDropdownIndex: index
        });
    }

    handleIngredientInputBlur = () => {
        // Delay to allow click on dropdown item
        setTimeout(() => {
            this.setState({
                showIngredientDropdown: false,
                activeDropdownIndex: null
            });
        }, 200);
    }

    // Packaging search handlers (similar to ingredient handlers)
    handlePackagingSearch = (searchValue, index) => {
        const filtered = this.state.originalPackagingParts.filter(part =>
            part.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            (part.id && part.id.toString().includes(searchValue))
        );

        const updatedParts = [...this.state.packagingParts];
        updatedParts[index].PartName = searchValue;

        this.setState({
            packagingParts: updatedParts,
            filteredPackagingParts: filtered,
            showPackagingDropdown: true,
            activePackagingDropdownIndex: index
        });
    }

    selectPackagingPart = (packagingPart, index) => {
        const updatedParts = [...this.state.packagingParts];

        // Check for duplicate PartID (excluding current row)
        const isDuplicate = updatedParts.some((part, idx) =>
            idx !== index && part.PartID === packagingPart.id
        );

        if (isDuplicate) {
            toast.error(`Part ID "${packagingPart.id}" is already added. Please select a different part.`);
            this.setState({
                showPackagingDropdown: false,
                activePackagingDropdownIndex: null
            });
            return;
        }

        console.log(packagingPart);

        updatedParts[index].PartID = packagingPart.id;
        updatedParts[index].PartName = packagingPart.name;
        updatedParts[index].RawsId = packagingPart.rawsId;

        console.log(updatedParts);

        this.setState({
            packagingParts: updatedParts,
            showPackagingDropdown: false,
            activePackagingDropdownIndex: null
        });
    }

    handlePackagingInputFocus = (index) => {
        this.setState({
            showPackagingDropdown: true,
            filteredPackagingParts: this.state.originalPackagingParts,
            activePackagingDropdownIndex: index
        });
    }

    handlePackagingInputBlur = () => {
        // Delay to allow click on dropdown item
        setTimeout(() => {
            this.setState({
                showPackagingDropdown: false,
                activePackagingDropdownIndex: null
            });
        }, 200);
    }

    // Capsule search handlers (similar to packaging handlers, but for single record)
    handleCapsuleSearch = (searchValue) => {
        const filtered = this.state.originalIngredientParts.filter(part =>
            part.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            (part.id && part.id.toString().includes(searchValue))
        );

        this.setState({
            capsule: {
                ...this.state.capsule,
                PartName: searchValue
            },
            filteredCapsuleParts: filtered,
            showCapsuleDropdown: true
        });
    }

    selectCapsulePart = (capsulePart) => {
        this.setState({
            capsule: {
                ...this.state.capsule,
                PartID: capsulePart.id,
                PartName: capsulePart.name,
                RawsId: capsulePart.rawsId
            },
            showCapsuleDropdown: false
        });
    }

    handleCapsuleInputFocus = () => {
        this.setState({
            showCapsuleDropdown: true,
            filteredPackagingParts: this.state.originalPackagingParts
        });
    }

    handleCapsuleInputBlur = () => {
        // Delay to allow click on dropdown item
        setTimeout(() => {
            this.setState({
                showCapsuleDropdown: false
            });
        }, 200);
    }

    // Searchable dropdown methods
    initializeSearchableDropdown = (index, type) => {
        const dropdownKey = `${type}_${index}`;
        const selectedPart = type === 'ingredient'
            ? this.state.ingredientParts[index]
            : this.state.packagingParts[index];

        // Always update the searchable dropdown state to reflect current part data
        this.setState(prevState => ({
            searchableDropdowns: {
                ...prevState.searchableDropdowns,
                [type]: {
                    ...prevState.searchableDropdowns[type],
                    [index]: {
                        searchTerm: selectedPart?.partName || '',
                        isOpen: prevState.searchableDropdowns[type]?.[index]?.isOpen || false,
                        selectedPart: selectedPart?.partId ? { id: selectedPart.partId, name: selectedPart.partName } : null
                    }
                }
            }
        }));
    }

    // Initialize all searchable dropdowns when parts data is loaded
    initializeAllSearchableDropdowns = () => {
        const newSearchableDropdowns = {
            ingredient: {},
            packaging: {}
        };

        // Initialize ingredient dropdowns
        this.state.ingredientParts.forEach((part, index) => {
            newSearchableDropdowns.ingredient[index] = {
                searchTerm: part.partName || '',
                isOpen: false,
                selectedPart: part.partId ? { id: part.partId, name: part.partName } : null
            };
        });

        // Initialize packaging dropdowns
        this.state.packagingParts.forEach((part, index) => {
            newSearchableDropdowns.packaging[index] = {
                searchTerm: part.partName || '',
                isOpen: false,
                selectedPart: part.partId ? { id: part.partId, name: part.partName } : null
            };
        });

        this.setState({ searchableDropdowns: newSearchableDropdowns });
    }

    handleSearchableDropdownChange = (index, value, type) => {
        this.setState(prevState => ({
            searchableDropdowns: {
                ...prevState.searchableDropdowns,
                [type]: {
                    ...prevState.searchableDropdowns[type],
                    [index]: {
                        ...prevState.searchableDropdowns[type][index],
                        searchTerm: value,
                        isOpen: true
                    }
                }
            }
        }));
    }

    handleSearchableDropdownSelect = (index, selectedPart, type) => {
        // Update the searchable dropdown state
        this.setState(prevState => ({
            searchableDropdowns: {
                ...prevState.searchableDropdowns,
                [type]: {
                    ...prevState.searchableDropdowns[type],
                    [index]: {
                        ...prevState.searchableDropdowns[type][index],
                        searchTerm: selectedPart.name,
                        isOpen: false,
                        selectedPart: selectedPart
                    }
                }
            }
        }), () => {
            // Then update the part using existing handler
            this.handlePartNameChange(index, selectedPart.id, type);
        });
    }

    handleSearchableDropdownFocus = (index, type) => {
        this.initializeSearchableDropdown(index, type);
        this.setState(prevState => ({
            searchableDropdowns: {
                ...prevState.searchableDropdowns,
                [type]: {
                    ...prevState.searchableDropdowns[type],
                    [index]: {
                        ...prevState.searchableDropdowns[type][index],
                        isOpen: true
                    }
                }
            }
        }));
    }

    handleSearchableDropdownBlur = (index, type) => {
        // Delay hiding to allow clicking on dropdown items
        setTimeout(() => {
            this.setState(prevState => ({
                searchableDropdowns: {
                    ...prevState.searchableDropdowns,
                    [type]: {
                        ...prevState.searchableDropdowns[type],
                        [index]: {
                            ...prevState.searchableDropdowns[type][index],
                            isOpen: false
                        }
                    }
                }
            }));
        }, 200);
    }

    getFilteredParts = (index, type) => {
        const searchTerm = this.state.searchableDropdowns[type]?.[index]?.searchTerm || '';
        const originalParts = type === 'ingredient'
            ? this.state.originalIngredientParts
            : this.state.originalPackagingParts;

        if (!searchTerm) return originalParts;

        return originalParts.filter(part =>
            part.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            part.id.toString().includes(searchTerm)
        );
    }

    convertToGram = (unit, numValue) => {
        let inGrams = 0;

        if (unit === 'mg') {
            inGrams = numValue / 1000; // mg to g
        } else if (unit === 'g') {
            inGrams = numValue; // already in grams
        } else if (unit === 'kg') {
            inGrams = numValue * 1000; // kg to g
        } else if (unit === 'mcg') {
            inGrams = numValue / 1000000; // mcg to g
        } else if (unit === 'ml') {
            inGrams = numValue; // assume 1ml = 1g for liquids
        } else if (unit === 'l') {
            inGrams = numValue * 1000; // l to g (assume 1l = 1000g)
        } else if (unit === 'IU' || unit === 'CFU' || unit === '%') {
            inGrams = numValue; // these don't convert to weight, return as-is
        } else {
            inGrams = numValue; // default case
        }

        return inGrams;
    }

    // Convert various units to grams
    convertToGrams = (value, unit) => {
        let inGrams = 0
        let byServingSize = 0
        const numValue = parseFloat(value);
        if (isNaN(numValue) || numValue <= 0) return 0;

        inGrams =  this.convertToGram = (unit, numValue);

        const servingSize = parseInt(this.state.servingSize || 0);

        if (servingSize > 0) {
            byServingSize = (inGrams / servingSize);
        } else {
            byServingSize = 0;
        }

        console.log("================");
        console.log(byServingSize);
        console.log("================");
        

        return byServingSize;

    }

    // Calculate amounts for all ingredient parts based on label claim and unit
    calculateAmountsForAllParts = (parts) => {
        return parts.map(part => {
            if (part.labelClaim && part.unit) {
                const amountInGrams = this.convertToGrams(part.labelClaim, part.unit);
                return {
                    ...part,
                    amount: amountInGrams.toFixed(8)
                };
            }
            return part;
        });
    }

    // Handle other ingredient part field changes
    handleIngredientPartChange = (index, field, value) => {
        const updatedParts = [...this.state.ingredientParts];
        updatedParts[index][field] = value;

        // Auto-calculate amount in grams when label claim or unit changes
        if (field === 'Amount' || field === 'Unit') {
            const labelClaim = field === 'labelAmountClaim' ? value : updatedParts[index].Amount;
            const unit = field === 'Unit' ? value : updatedParts[index].Unit;

            if (labelClaim && unit) {
                const amountInGrams = this.convertToGrams(labelClaim, unit);
                updatedParts[index].AmountPerServing = amountInGrams.toFixed(8);
            }
        }

        this.setState({ ingredientParts: updatedParts }, () => {
            // Update fill weight when amount changes
            if (field === 'Amount' || field === 'Unit' || field === 'amountPerServing') {
                this.checkAndUpdateFillWeight();
            }
        });
    }

    // Handle other packaging part field changes
    handlePackagingPartChange = (index, field, value) => {
        const updatedParts = [...this.state.packagingParts];
        updatedParts[index][field] = value;
        this.setState({ packagingParts: updatedParts });
    }

    // Add new ingredient part row
    addIngredientPart = () => {
        const newPart = {
            RfqIngredientPartId: 0,
            RfqId: 0,
            PartID: '',
            PartName: '',
            Amount: '',
            Overage: '',
            RawsId: 0,
            AmountPerServing: 0,
            Unit: '',
            Source: 0,
            Type: 0,
            OverageCost: 0,
            IsCsm: 0,
            filteredParts: this.state.originalIngredientParts
        };

        this.setState({
            ingredientParts: [...this.state.ingredientParts, newPart]
        }, () => {
            // Initialize searchable dropdown for the new part
            this.initializeAllSearchableDropdowns();
            // Update fill weight after adding new ingredient part
            this.checkAndUpdateFillWeight();
        });
    }

    // Add new packaging part row
    addPackagingPart = (servingUnitId = 0) => {
        const newPart = {
            RfqPackagingPartId: 0,
            RfqId: 0,
            RawsId: 0,
            PartID: '',
            PartName: '',
            Amount: '',
            OverageCost: '',
            IsCsm: '',
            RfqServingUnitId: servingUnitId,
            filteredParts: this.state.originalPackagingParts
        };

        this.setState({
            packagingParts: [...this.state.packagingParts, newPart]
        }, () => {
            // Initialize searchable dropdown for the new part
            this.initializeAllSearchableDropdowns();
        });
    }

    // Remove ingredient part row
    removeIngredientPart = async (index) => {
        if (this.state.ingredientParts.length > 1) {
            const updatedParts = [...this.state.ingredientParts];
            updatedParts[index] = {
                ...updatedParts[index],
                deleted: true
            };

            this.setState({ ingredientParts: updatedParts }, () => {
                // Reinitialize searchable dropdowns after marking as deleted
                this.initializeAllSearchableDropdowns();
                // Update fill weight after removing ingredient part
                this.checkAndUpdateFillWeight();
            });
        }
    }

    toggleIngredientCSM = (index) => {
        const updatedParts = [...this.state.ingredientParts];
        updatedParts[index].IsCsm = updatedParts[index].IsCsm ? 0 : 1;
        this.setState({ ingredientParts: updatedParts });
    }

    // Remove packaging part row
    removePackagingPart = (index) => {
        if (this.state.packagingParts.length > 1) {
            const updatedParts = [...this.state.packagingParts];
            updatedParts[index] = {
                ...updatedParts[index],
                deleted: true
            };
            this.setState({ packagingParts: updatedParts }, () => {
                // Reinitialize searchable dropdowns after removal
                this.initializeAllSearchableDropdowns();
            });
        }
    }

    togglePackagingCSM = (index) => {
        const updatedParts = [...this.state.packagingParts];
        updatedParts[index].IsCsm = updatedParts[index].IsCsm ? 0 : 1;
        this.setState({ packagingParts: updatedParts });
    }

    // Testing methods
    addTestingItem = () => {
        this.setState(prevState => ({
            testingItems: [...prevState.testingItems, {
                testingType: '',
                cost: '',
                numberOfIngredients: 0,
                RfqTestingIds: [], // Initialize empty array for new items
                RfqId: 0
            }]
        }));
    }

    removeTestingItem = (index) => {
        const updatedItems = [...this.state.testingItems];
        const itemToDelete = updatedItems[index];

        // Mark for deletion instead of removing from array immediately
        // This will be sent to backend to delete all records with this TestName
        updatedItems[index] = {
            ...itemToDelete,
            deleted: 1
        };

        this.setState({ testingItems: updatedItems });
    }

    handleTestingChange = (index, field, value) => {
        const updatedItems = [...this.state.testingItems];
        updatedItems[index][field] = value;
        this.setState({ testingItems: updatedItems });
    }

    calculateTestingTotal = () => {
        return this.state.testingItems.reduce((total, item) => {
            // Skip deleted items
            if (item.deleted) return total;

            const cost = parseFloat(item.cost) || 0;
            const numIngredients = parseInt(item.numberOfIngredients) || 0;
            return total + (cost * numIngredients);
        }, 0);
    }

    // Modal handlers
    handleOpenAddRawsModal = () => {
        this.setState({ showAddRawsModal: true });
    }

    handleCloseAddRawsModal = () => {
        this.setState({ showAddRawsModal: false });
    }

    // Calculator Modal handlers
    handleOpenCalculatorModal = (index) => {

        const part = this.state.ingredientParts[index];

        console.log('my part', part);

        const selectedPartData = this.state.originalIngredientParts.find(p => p.id === part.PartID);

        console.log('selectedPartData', selectedPartData);

        const activeInactiveOptions = [];
        let activeInactiveOption = '';

        activeInactiveOptions.push({
            label: 'Active',
            value: 'Active'
        });
        activeInactiveOptions.push({
            label: 'Inactive',
            value: 'Inactive'
        });

        // First check if saved in database, otherwise use raw material data
        if(part.ActiveInactiveOption)
        {
            activeInactiveOption = part.ActiveInactiveOption;
        }
        else if(selectedPartData && selectedPartData.ActiveInactive)
        {
            let activeInactive = selectedPartData.ActiveInactive.toLowerCase().trim();
            if(activeInactive === "active")
            {
                activeInactiveOption = 'Active'
            }
            else if(activeInactive === "inactive")
            {
                activeInactiveOption = 'Inactive'
            }
        }



        const limitOptions = [];
        if (selectedPartData) {
            if (selectedPartData.limit1) {
                limitOptions.push({
                    label: 'Limit-1',
                    value: 'Limit-1',
                    limit: selectedPartData.limit1 || ''
                });
            }
            if (selectedPartData.limit2) {
                limitOptions.push({
                    label: 'Limit-2',
                    value: 'Limit-2',
                    limit: selectedPartData.limit2 || ''
                });
            }
        }

        let amountRequiredPerServing = 0;
        let amountRequiredPerCapsule = 0;
        let selectedLimit = part.SelectedLimit || '';
        let limit = 0;

        let overage = parseFloat(part.Overage);
        overage = overage/100;
        // If there's a saved selectedLimit, find its limit value
        if(selectedLimit && limitOptions.length > 0)
        {
            const savedLimitOption = limitOptions.find(opt => opt.value === selectedLimit);
            if(savedLimitOption)
            {
                limit = parseFloat(savedLimitOption.limit);
            }
        }

        if(activeInactiveOption === "Inactive")
        {
                amountRequiredPerServing = parseFloat(part.Amount);
                amountRequiredPerCapsule = amountRequiredPerServing/parseFloat(this.state.servingSize);
                amountRequiredPerCapsule = overage * amountRequiredPerCapsule;
                amountRequiredPerCapsule = this.convertToGram(part.Unit, amountRequiredPerCapsule);
                amountRequiredPerCapsule = amountRequiredPerCapsule.toFixed(8);
        }
        else if(activeInactiveOption === "Active" && selectedLimit && limit > 0)
        {
                amountRequiredPerServing = parseFloat(part.Amount)/limit;
                amountRequiredPerCapsule = amountRequiredPerServing/parseFloat(this.state.servingSize);
                amountRequiredPerCapsule = overage * amountRequiredPerCapsule;
                amountRequiredPerCapsule = this.convertToGram(part.Unit, amountRequiredPerCapsule);
                amountRequiredPerCapsule = amountRequiredPerCapsule.toFixed(8);
        }

        this.setState({
            showCalculatorModal: true,
            calculatorTargetIndex: index,
            calculatorTargetIndexOverage: part.Overage,
            calculatorData: {
                activeInactiveOptions: activeInactiveOptions,
                activeInactiveOption: activeInactiveOption,
                amount: part.Amount,
                unit: part.Unit,
                limitOptions: limitOptions,
                selectedLimit: selectedLimit,
                limit: limit,
                amountRequiredPerServing: amountRequiredPerServing,
                amountRequiredPerCapsule: amountRequiredPerCapsule,
                finalAmount: 0
            }
        }, () => {
            // console.log('Modal state after update:', this.state.showCalculatorModal);
            // console.log('Active options:', activeOptions);
        });
    }

    handleCalculatorDataChange = (field, value) => {

        console.log(field);
        console.log(value);

        this.setState(prevState => {
            const updatedData = {
                ...prevState.calculatorData,
                [field]: value
            };

            if(field === "selectedLimit") {
                const selectedLimit = prevState.calculatorData.limitOptions.find(
                    opt => opt.value === value
                );



                updatedData.limit = parseFloat(selectedLimit.limit);
                updatedData.amountRequiredPerServing = parseFloat(updatedData.amount)/updatedData.limit;
                updatedData.amountRequiredPerCapsule = updatedData.amountRequiredPerServing/parseFloat(this.state.servingSize);
                updatedData.amountRequiredPerCapsule = this.convertToGram(updatedData.unit, updatedData.amountRequiredPerCapsule);
                updatedData.amountRequiredPerCapsule = updatedData.amountRequiredPerCapsule.toFixed(8);


                console.log(updatedData);
            }

            let overage = parseFloat(this.state.calculatorTargetIndexOverage);
            overage = overage/100;

            if(field === "activeInactiveOption") {
                let amountRequiredPerServing = 0;
                let amountRequiredPerCapsule = 0;

                if(value === "Inactive") {
                    amountRequiredPerServing = parseFloat(updatedData.amount);
                    amountRequiredPerCapsule = amountRequiredPerServing/parseFloat(this.state.servingSize);
                    amountRequiredPerCapsule = overage * amountRequiredPerCapsule;
                    amountRequiredPerCapsule = this.convertToGram(updatedData.unit, amountRequiredPerCapsule);
                    amountRequiredPerCapsule = amountRequiredPerCapsule.toFixed(8);
                } else if(value === "Active" && updatedData.selectedLimit && updatedData.limit > 0) {
                    amountRequiredPerServing = parseFloat(updatedData.amount)/updatedData.limit;
                    amountRequiredPerCapsule = amountRequiredPerServing/parseFloat(this.state.servingSize);
                    amountRequiredPerCapsule = overage * amountRequiredPerCapsule;
                    amountRequiredPerCapsule = this.convertToGram(updatedData.unit, amountRequiredPerCapsule);
                    amountRequiredPerCapsule = amountRequiredPerCapsule.toFixed(8);
                }

                updatedData.amountRequiredPerServing = amountRequiredPerServing;
                updatedData.amountRequiredPerCapsule = amountRequiredPerCapsule;
            }

            return {
                calculatorData: updatedData
            };
        });

    }

    handleCloseCalculatorModal = () => {
        this.setState({
            showCalculatorModal: false,
            calculatorTargetIndex: null,
            calculatorData: {
                activeInactiveOptions: [],
                activeInactiveOption: '',
                amount: '',
                unit: '',
                limitOptions: [],
                selectedLimit: '',
                limit: 0,
                amountRequiredPerServing: 0,
                amountRequiredPerCapsule: 0,
                finalAmount: 0
            }
        });
    }

    recalculateCalculatorData = () => {
        const { ingredientParts, servingSize } = this.state;

        if (!servingSize || parseFloat(servingSize) === 0) {
            return;
        }

        // Recalculate all ingredient parts that have calculator data
        const updatedIngredientParts = ingredientParts.map(part => {
            // Only recalculate if this part has saved calculator data
            if (!part.ActiveInactiveOption || !part.Amount) {
                return part;
            }

            let amountRequiredPerServing = 0;
            let amountRequiredPerCapsule = 0;

            if (part.ActiveInactiveOption === "Inactive") {
                amountRequiredPerServing = parseFloat(part.Amount);
                amountRequiredPerCapsule = amountRequiredPerServing / parseFloat(servingSize);
                amountRequiredPerCapsule = this.convertToGram(part.Unit, amountRequiredPerCapsule);
                amountRequiredPerCapsule = parseFloat(amountRequiredPerCapsule.toFixed(8));
            } else if (part.ActiveInactiveOption === "Active" && part.SelectedLimit) {
                // Find the limit value from the raw material data
                const selectedPartData = this.state.originalIngredientParts.find(p => p.id === part.PartID);
                if (selectedPartData) {
                    let limit = 0;
                    if (part.SelectedLimit === 'Limit-1' && selectedPartData.limit1) {
                        limit = parseFloat(selectedPartData.limit1);
                    } else if (part.SelectedLimit === 'Limit-2' && selectedPartData.limit2) {
                        limit = parseFloat(selectedPartData.limit2);
                    }

                    if (limit > 0) {
                        amountRequiredPerServing = parseFloat(part.Amount) / limit;
                        amountRequiredPerCapsule = amountRequiredPerServing / parseFloat(servingSize);
                        amountRequiredPerCapsule = this.convertToGram(part.Unit, amountRequiredPerCapsule);
                        amountRequiredPerCapsule = parseFloat(amountRequiredPerCapsule.toFixed(8));
                    }
                }
            }

            return {
                ...part,
                AmountPerServing: amountRequiredPerCapsule
            };
        });

        this.setState({
            ingredientParts: updatedIngredientParts
        });
    }

    handleCalculatorApply = async () => {
        const { calculatorData, calculatorTargetIndex, ingredientParts } = this.state;
         if (calculatorTargetIndex !== null) {
            try {
                this.handleIngredientPartChange(calculatorTargetIndex, 'amountPerServing', calculatorData.amountRequiredPerCapsule);


                const updatedIngredientParts = [...ingredientParts];
                updatedIngredientParts[calculatorTargetIndex] = {
                    ...updatedIngredientParts[calculatorTargetIndex],
                    AmountPerServing: calculatorData.amountRequiredPerCapsule,
                    ActiveInactiveOption: calculatorData.activeInactiveOption,
                    SelectedLimit: calculatorData.selectedLimit
                };

                this.setState({
                    ingredientParts: updatedIngredientParts
                });

                console.log(updatedIngredientParts);

                // const response = await axios.post('/formula/update-ingredient-part', {
                //     rfqId: this.state.selectedRfq?.id,
                //     partIndex: calculatorTargetIndex,
                //     amountPerServing: calculatorData.amountRequiredPerCapsule
                // });

                // if (response.data.success) {
                //     // console.log('Database updated successfully');
                //     toast.success('Amount calculated and saved to database successfully');
                // } else {
                //     console.error('Database update failed:', response.data);
                //     toast.warning('Amount calculated locally. Please save the formula to persist changes.');
                // }
            }
            catch (error) {
                console.error('Error updating database:', error);
                // Don't show error if endpoint doesn't exist - it might be a new formula
                toast.success('Amount calculated. Please save the formula to persist changes.');
            }

         }
        

        this.handleCloseCalculatorModal();
    }

    handleRawMaterialSaved = (newRawMaterial) => {
        // Handle the newly saved raw material
        // console.log('New raw material saved:', newRawMaterial);
        toast.success(`Raw material "${newRawMaterial.rawMaterialName}" added successfully!`);

        // Transform the new part to match our data structure
        const newPart = {
            id: newRawMaterial.id,
            name: newRawMaterial.rawMaterialName,
            rawsId: newRawMaterial.rawsId || newRawMaterial.id
        };

        // Determine which list to add to based on ID range
        const numId = parseInt(newPart.id);
        let addedToSection = null;

        if (numId >= 60000 && numId <= 69999) {
            // Add to ingredient parts (raw materials)
            const updatedIngredientParts = [...this.state.originalIngredientParts, newPart];

            // Update all ingredient rows to include the new part
            const updatedIngredientRows = this.state.ingredientParts.map(part => ({
                ...part,
                filteredParts: part.filteredParts ? [...part.filteredParts, newPart] : updatedIngredientParts
            }));

            this.setState({
                originalIngredientParts: updatedIngredientParts,
                filteredIngredientParts: updatedIngredientParts,
                ingredientParts: updatedIngredientRows
            });

            addedToSection = 'Ingredient Parts';
        } else if (numId >= 70000 && numId <= 89999) {
            // Add to packaging parts
            const updatedPackagingParts = [...this.state.originalPackagingParts, newPart];

            // Update all packaging rows to include the new part
            const updatedPackagingRows = this.state.packagingParts.map(part => ({
                ...part,
                filteredParts: part.filteredParts ? [...part.filteredParts, newPart] : updatedPackagingParts
            }));

            this.setState({
                originalPackagingParts: updatedPackagingParts,
                filteredPackagingParts: updatedPackagingParts,
                packagingParts: updatedPackagingRows
            });

            addedToSection = 'Packaging Parts';
        }


        if (addedToSection) {
            toast.success(`Part added to ${addedToSection} section!`);
        } else {
            toast.info('Part created but not added to any section (ID outside 60000-69999 or 70000-89999 range)');
        }
    }

    handleBackToRfq = () => {
        const { selectedRfq } = this.state;

        if (selectedRfq && selectedRfq.id) {
            // Update RFQ status to 2
            axios.put(`/rfq/${selectedRfq.id}`, {
                RfqStatus: 1
            })
            .then(response => {
                if (response.data.success) {
                    toast.success('RFQ status updated successfully');
                    // Redirect to RFQ page
                    window.location.href = '/request-quote';
                } else {
                    toast.error('Failed to update RFQ status');
                }
            })
            .catch(error => {
                console.error('Error updating RFQ status:', error);
                toast.error('Error updating RFQ status');
                // Still redirect even if update fails
                window.location.href = '/request-quote';
            });
        } else {
            // If no RFQ selected, just redirect
            window.location.href = '/request-quote';
        }
    }

    render() {
        const {
            selectedRfq,
            company,
            formulaNumber,
            formulaName,
            productName,
            form,
            servingSize,
            servingsPerUnit,
            salesRep,
            assignedTo,
            orderType,
            itemNumber,
            sharepointLink,
            capsuleSize,
            capsuleSpecifications,
            capsuleWeight,
            capsuleColor,
            capsuleFillWeight,
            capsuleRange,
            capsuleTotalWeight,
            tabletWeight,
            tabletShape,
            liquidDensity,
            loading,
            savingDraft,
            availableRfqs,
            loadingRfqs,
            errors,
            showAddRawsModal,
            showCalculatorModal,
            calculatorData,
            filteredIngredientParts,
            filteredPackagingParts,
            loadingParts,
            ingredientParts,
            packagingParts,
            isEditMode,
            packagingType,
            packagingCsm,
            newIngredientPartId,
            newIngredientPartName
        } = this.state;

        return (
            <Layout>
                <style>{formStyles}</style>
                <div style={{ height: 'calc(100vh - 70px)', overflow: 'auto', paddingTop: '20px' }}>
                    <section className="section pb-0" style={{ paddingTop: '20px' }}>
                        <div style={{ paddingLeft: '24px', paddingRight: '24px', maxWidth: '100%', width: '100%' }}>

                            {/* Header */}
                            <div className="mb-4">
                                <div style={{ fontSize: '28px', fontWeight: 'bold', margin: 0, color: '#000000', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>
                                      
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Form.Label style={{ fontSize: '14px', margin: 0, whiteSpace: 'nowrap' }}>Assigned To *</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="assignedTo"
                                            value={assignedTo}
                                            onChange={(e) => this.setState({ assignedTo: e.target.value })}
                                            style={{ width: '200px' }}
                                            required
                                        >
                                            <option value="">Select Assigned To</option>
                                            {this.state.salesReps.map(rep => (
                                                <option key={rep.id} value={rep.id}>
                                                    {rep.fullname}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </div>
                                </div>
                            </div>

                            <Form>
                                {/* Packaging Info (from RFQ) */}
                                {(packagingType || packagingCsm) && (
                                    <div className="form-section mb-3">
                                        <div className="section-header">
                                            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Packaging Info</h5>
                                        </div>
                                        <div className="section-content">
                                            <Row>
                                                {packagingType && (
                                                    <Col md={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Packaging Type</Form.Label>
                                                            <Form.Control type="text" value={packagingType} readOnly disabled />
                                                        </Form.Group>
                                                    </Col>
                                                )}
                                                <Col md={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Customer Supplied Material</Form.Label>
                                                        <Form.Control type="text" value={packagingCsm ? 'Yes' : 'No'} readOnly disabled />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )}

                                {/* Formula Details */}
                                <div className="form-section">
                                    <div className="section-header">
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Formula Details</h5>
                                    </div>
                                    <div className="section-content">
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Link to RFQ *</Form.Label>
                                                    {selectedRfq ? (
                                                        // Show RFQ information when available
                                                        <>
                                                            <Form.Control
                                                                type="text"
                                                                value={`${selectedRfq.rfqNumber || 'RFQ-XXXX'} - ${selectedRfq.company || 'Unknown Company'} - ${selectedRfq.product || 'Unknown Product'}`}
                                                                disabled={isEditMode}
                                                                readOnly={isEditMode}
                                                                style={isEditMode ? { backgroundColor: '#f8f9fa', color: '#495057', cursor: 'not-allowed' } : {}}
                                                                onClick={!isEditMode ? () => {
                                                                    // In create mode, allow clicking to open dropdown
                                                                    document.querySelector('select[data-rfq-dropdown]')?.focus();
                                                                } : undefined}
                                                            />
                                                            {isEditMode && (
                                                                <Form.Text className="text-muted">
                                                                    RFQ cannot be changed in edit mode
                                                                </Form.Text>
                                                            )}
                                                            {!isEditMode && (
                                                                <div style={{ display: 'none' }}>
                                                                    <Form.Select
                                                                        data-rfq-dropdown
                                                                        value={selectedRfq.id}
                                                                        onChange={(e) => {
                                                                            if (e.target.value === '') {
                                                                                this.clearRfqSelection();
                                                                            } else {
                                                                                const rfq = availableRfqs.find(r => r.id === parseInt(e.target.value));
                                                                                if (rfq) {
                                                                                    // Load detailed RFQ data including ingredient parts
                                                                                    this.loadSpecificRfqForSelection(rfq.id);
                                                                                }
                                                                            }
                                                                        }}
                                                                        disabled={loadingRfqs}
                                                                    >
                                                                        <option value="">{loadingRfqs ? 'Loading RFQs...' : 'Select RFQ to link'}</option>
                                                                        {availableRfqs.map(rfq => (
                                                                            <option key={rfq.id} value={rfq.id}>
                                                                                {rfq.rfqNumber} - {rfq.company} - {rfq.product}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        // Show dropdown when no RFQ is selected
                                                        <>
                                                            <div className="custom-dropdown">
                                                                <Form.Select
                                                                    value=""
                                                                    onChange={(e) => {
                                                                        // console.log('RFQ dropdown changed:', e.target.value);
                                                                        if (e.target.value === '') {
                                                                            this.clearRfqSelection();
                                                                        } else {
                                                                            const rfq = availableRfqs.find(r => r.id === parseInt(e.target.value));
                                                                            // console.log('Selected RFQ:', rfq);
                                                                            if (rfq) {
                                                                                // Load detailed RFQ data including ingredient parts
                                                                                // console.log('Loading detailed RFQ data for:', rfq.id);
                                                                                this.loadSpecificRfqForSelection(rfq.id);
                                                                            }
                                                                        }
                                                                    }}
                                                                    disabled={loadingRfqs}
                                                                    isInvalid={!!errors.rfq}
                                                                    required
                                                                >
                                                                    <option value="">{loadingRfqs ? 'Loading RFQs...' : 'Select RFQ to link'}</option>
                                                                    {availableRfqs.map(rfq => (
                                                                        <option key={rfq.id} value={rfq.id}>
                                                                            {rfq.rfqNumber} - {rfq.company} - {rfq.product}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                            </div>
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.rfq}
                                                            </Form.Control.Feedback>
                                                        </>
                                                    )}
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Customer *</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Company"
                                                        value={company}
                                                        onChange={(e) => this.handleInputChange('company', e.target.value)}
                                                        required
                                                        isInvalid={!!errors.company}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.company}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>

                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Formula ID</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={formulaNumber}
                                                        disabled
                                                        style={{ backgroundColor: '#f8f9fa', color: '#6c757d' }}
                                                        placeholder={selectedRfq ? '' : 'Select an RFQ'}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Load Existing Formula</Form.Label>
                                                    <div className="input-group">
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="e.g. FORM-0006"
                                                            value={this.state.formulaLookupInput}
                                                            onChange={(e) => this.setState({ formulaLookupInput: e.target.value, formulaLookupError: '' })}
                                                            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.lookupFormula(); }}}
                                                            disabled={this.state.formulaLookupLoading}
                                                        />
                                                        <button
                                                            className="btn btn-outline-primary"
                                                            type="button"
                                                            onClick={() => this.lookupFormula()}
                                                            disabled={this.state.formulaLookupLoading || !this.state.formulaLookupInput.trim()}
                                                        >
                                                            {this.state.formulaLookupLoading ? (
                                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                            ) : (
                                                                <i className="ti-search"></i>
                                                            )}
                                                        </button>
                                                    </div>
                                                    {this.state.formulaLookupError && (
                                                        <Form.Text className="text-danger">{this.state.formulaLookupError}</Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Formula Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Formula Number"
                                                        value={formulaName}
                                                        onChange={(e) => this.handleInputChange('formulaName', e.target.value)}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="d-block">Form *</Form.Label>
                                                    <Form.Select
                                                        value={form}
                                                        onChange={(e) => this.handleInputChange('form', e.target.value)}
                                                        required
                                                        isInvalid={!!errors.form}
                                                    >
                                                        <option>Select form</option>
                                                        <option value="capsule">Capsule</option>
                                                        <option value="tablet">Tablet</option>
                                                        <option value="powder">Powder</option>
                                                        <option value="liquid">Liquid</option>
                                                        <option value="gummy">Gummy</option>
                                                        <option value="softgel">Softgel</option>
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.form}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Product Name *</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Product Name"
                                                        value={productName}
                                                        onChange={(e) => this.handleInputChange('productName', e.target.value)}
                                                        required
                                                        isInvalid={!!errors.productName}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.productName}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Serving Size *</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="e.g., 2 capsules"
                                                        value={servingSize}
                                                        onChange={(e) => this.handleInputChange('servingSize', e.target.value)}
                                                        required
                                                        isInvalid={!!errors.servingSize}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.servingSize}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Servings/Unit *</Form.Label>
                                                    {this.state.servingUnits && this.state.servingUnits.length > 0 ? (
                                                        this.state.servingUnits.map((unit, index) => (
                                                            <Form.Control
                                                                key={index}
                                                                type="text"
                                                                value={unit.ServingUnit}
                                                                readOnly
                                                                disabled
                                                                style={{
                                                                    backgroundColor: '#f8f9fa',
                                                                    cursor: 'not-allowed',
                                                                    marginBottom: index < this.state.servingUnits.length - 1 ? '8px' : '0'
                                                                }}
                                                            />
                                                        ))
                                                    ) : (
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="e.g., 30"
                                                            value={servingsPerUnit}
                                                            onChange={(e) => this.handleInputChange('servingsPerUnit', e.target.value)}
                                                            required
                                                            isInvalid={!!errors.servingsPerUnit}
                                                        />
                                                    )}
                                                    {!this.state.servingUnits || this.state.servingUnits.length === 0 ? (
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.servingsPerUnit}
                                                        </Form.Control.Feedback>
                                                    ) : null}
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="d-block">Order Type</Form.Label>
                                                    <Form.Select
                                                        name="orderType"
                                                        value={orderType}
                                                        onChange={(e) => this.setState({ orderType: e.target.value })}
                                                    >
                                                        <option value="">Select order type</option>
                                                        <option value="Reorder">Reorder</option>
                                                        <option value="NPD">NPD</option>
                                                        <option value="Re-Formulation">Re-Formulation</option>
                                                        <option value="New to APEX Product">New to APEX Product</option>
                                                        <option value="Blanket">Blanket</option>
                                                        <option value="Re-Formulation">Re-Formulation</option>
                                                        <option value="Change Order">Change Order</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            {orderType && orderType !== '' && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Item Number</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="itemNumber"
                                                            placeholder="Enter item number"
                                                            value={itemNumber}
                                                            readOnly
                                                            style={{ backgroundColor: '#f8f9fa', color: '#495057' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}
                                            {sharepointLink && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Sharepoint Link</Form.Label>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <Form.Control
                                                                type="text"
                                                                name="sharepointLink"
                                                                value={sharepointLink}
                                                                readOnly
                                                                style={{ flex: 1, backgroundColor: '#f8f9fa', cursor: 'pointer' }}
                                                                onClick={() => window.open(sharepointLink, '_blank')}
                                                            />
                                                            <a
                                                                href={sharepointLink}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    color: '#007bff',
                                                                    cursor: 'pointer',
                                                                    fontSize: '18px',
                                                                    textDecoration: 'none'
                                                                }}
                                                                title="Open in new tab"
                                                            >
                                                                <i className="ti-new-window"></i>
                                                            </a>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            )}
                                        </Row>
                                    </div>
                                </div>

                                {/* Capsule Details - Show when form is Capsule */}
                                {form === 'capsule' && (
                                    <div className="form-section">
                                        <div className="section-header">
                                            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Capsule Details</h5>
                                        </div>
                                        <div className="section-content">
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Capsule Size</Form.Label>
                                                        <Form.Select
                                                            size="sm"
                                                            style={{ fontSize: '14px' }}
                                                            value={capsuleSize}
                                                            onChange={(e) => this.handleCapsuleSizeChange(e.target.value)}
                                                        >
                                                            <option value="">Select capsule size</option>
                                                            <option value="4">4</option>
                                                            <option value="3">3</option>
                                                            <option value="2">2</option>
                                                            <option value="1">1</option>
                                                            <option value="0">0</option>
                                                            <option value="0E">0E</option>
                                                            <option value="00">00</option>
                                                            <option value="00E">00E</option>
                                                            <option value="000">000</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Capsule Specifications (Shell Type)</Form.Label>
                                                        <Form.Select
                                                            size="sm"
                                                            style={{ fontSize: '14px' }}
                                                            value={capsuleSpecifications}
                                                            onChange={(e) => this.handleInputChange('capsuleSpecifications', e.target.value)}
                                                        >
                                                            <option value="">Select shell type</option>
                                                            <option value="delayed-release-hpmc">Delayed Release HPMC</option>
                                                            <option value="gelatin">Gelatin</option>
                                                            <option value="hypromellose-hpmc">Hypromellose (HPMC)</option>
                                                            <option value="pullulan">Pullulan</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Capsule Weight (g)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="0.000"
                                                            step="0.001"
                                                            size="sm"
                                                            style={{ fontSize: '14px' }}
                                                            value={capsuleWeight}
                                                            onChange={(e) => this.handleInputChange('capsuleWeight', e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Capsule Color</Form.Label>
                                                        <Form.Select
                                                            size="sm"
                                                            style={{ fontSize: '14px' }}
                                                            value={capsuleColor}
                                                            onChange={(e) => this.handleInputChange('capsuleColor', e.target.value)}
                                                        >
                                                            <option value="">Select capsule color</option>
                                                            <option value="black">Black</option>
                                                            <option value="clear">Clear</option>
                                                            <option value="dark-blue">Dark Blue</option>
                                                            <option value="green">Green</option>
                                                            <option value="light-blue">Light Blue</option>
                                                            <option value="purple">Purple</option>
                                                            <option value="red">Red</option>
                                                            <option value="white">White</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Fill Weight (g)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="0.000"
                                                            step="0.001"
                                                            size="sm"
                                                            readOnly
                                                            style={{ fontSize: '14px', backgroundColor: '#f8f9fa' }}
                                                            value={capsuleFillWeight}
                                                            onChange={(e) => this.handleInputChange('capsuleFillWeight', e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Range (g)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="0.000"
                                                            step="0.001"
                                                            size="sm"
                                                            style={{ fontSize: '14px' }}
                                                            value={capsuleRange}
                                                            onChange={(e) => this.handleInputChange('capsuleRange', e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Total Weight (g)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="0.000"
                                                            step="0.001"
                                                            size="sm"
                                                            style={{ fontSize: '14px', backgroundColor: '#f8f9fa' }}
                                                            value={capsuleTotalWeight}
                                                            readOnly
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )}

                                {/* Tablet Details - Show when form is Tablet */}
                                {form === 'tablet' && (
                                    <div className="form-section">
                                        <div className="section-header">
                                            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Tablet Details</h5>
                                        </div>
                                        <div className="section-content">
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Tablet Weight (g)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="0.000"
                                                            step="0.001"
                                                            size="sm"
                                                            style={{ fontSize: '14px' }}
                                                            value={tabletWeight}
                                                            onChange={(e) => this.handleInputChange('tabletWeight', e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Tablet Shape</Form.Label>
                                                        <Form.Select
                                                            size="sm"
                                                            style={{ fontSize: '14px' }}
                                                            value={tabletShape}
                                                            onChange={(e) => this.handleInputChange('tabletShape', e.target.value)}
                                                        >
                                                            <option value="">Select tablet shape</option>
                                                            <option value="B/BB/B2-9.48x9.48-round-no-bisect">B/BB/B2 9.48 x 9.48 mm Round w/o bisect</option>
                                                            <option value="D-19.05x8.13-capsule-no-bisect">D 19.05 x 8.13 mm Capsule w/o bisect</option>
                                                            <option value="D-23.11x10.01-modern-capsule-no-bisect">D 23.11 x 10.01 mm Modern Capsule w/o bisect</option>
                                                            <option value="D-19.5x8.25-capsule-with-bisect">D 19.5 x 8.25 mm Capsule w/ bisect</option>
                                                            <option value="D-19.5x8.25-capsule-no-bisect">D 19.5 x 8.25 mm Capsule w/o bisect</option>
                                                            <option value="D-8.25x8.25-round-no-bisect">D 8.25 x 8.25 mm Round w/o bisect</option>
                                                            <option value="D-13.5x13.5-round-no-bisect">D 13.5 x 13.5 mm Round w/o bisect</option>
                                                            <option value="D-25x25-round-no-bisect">D 25 x 25 mm Round w/o bisect</option>
                                                            <option value="D-18.8x7.94-modern-capsule-no-bisect">D 18.8 x 7.94 mm Modern Capsule w/o bisect</option>
                                                            <option value="D-16x16-round-with-bisect">D 16 x 16 mm Round w/ bisect</option>
                                                            <option value="D-25x10-capsule-with-bisect">D 25 x 10 mm Capsule w/ bisect</option>
                                                            <option value="D-24x10.5-modern-capsule-with-bisect">D 24 x 10.5 mm Modern Capsule w/ bisect</option>
                                                            <option value="D-24x9.75-modern-capsule-with-bisect">D 24 x 9.75 mm Modern Capsule w/ bisect</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )}

                                {/* Powder Formulation Details - Show when form is Powder */}
                                {form === 'powder' && (
                                    <div className="form-section">
                                        <div className="section-header">
                                            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Formulation Details</h5>
                                        </div>
                                        <div className="section-content">
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Serving Size (g)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="2"
                                                            step="0.1"
                                                            size="sm"
                                                            style={{ fontSize: '14px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )}

                                {/* Liquid Formulation Details - Show when form is Liquid */}
                                {form === 'liquid' && (
                                    <div className="form-section">
                                        <div className="section-header">
                                            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Formulation Details</h5>
                                        </div>
                                        <div className="section-content">
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Serving Size (ml)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="2"
                                                            step="0.1"
                                                            size="sm"
                                                            style={{ fontSize: '14px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Density (g/mL)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="1.0"
                                                            step="0.01"
                                                            size="sm"
                                                            style={{ fontSize: '14px' }}
                                                            value={liquidDensity}
                                                            onChange={(e) => this.handleInputChange('liquidDensity', e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )}

                                {/* Ingredient Parts Section - Only show when RFQ is selected */}
                                {selectedRfq && (
                                    <div className="form-section">
                                    <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Ingredient Parts</h5>
                                        <Button
                                            variant="info"
                                            size="sm"
                                            style={{ backgroundColor: '#007BFF', border: 'none', fontSize: '12px', padding: '4px 8px' }}
                                            onClick={this.handleOpenAddRawsModal}
                                        >
                                            Create New Part
                                        </Button>
                                    </div>
                                    <div className="section-content">
                                        <div className='row'>
                                            <div className='col-6'>
                                                <ImageGrid imageUrls={this.state.sfpImages} />
                                            </div>
                                        </div>
                                        {ingredientParts.map((part, index) => (
                                            <Row key={index} className={`align-items-end${part.deleted === true ? ' hide-me' : ''}`} style={{ marginBottom: '10px' }}>
                                                <Col md={1}>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Part ID#</Form.Label>
                                                        <Form.Control
                                                            size="sm"
                                                            placeholder="Part ID#"
                                                            value={part.PartID}
                                                            onChange={(e) => this.handlePartIdChange(index, e.target.value, 'ingredient')}
                                                            style={{ fontSize: '14px' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="mb-2 searchable-dropdown">
                                                        <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Part Name</Form.Label>
                                                        <Form.Control
                                                            size="sm"
                                                            type="text"
                                                            placeholder={loadingParts ? 'Loading parts...' : 'Search ingredients...'}
                                                            value={part.PartName || ''}
                                                            onChange={(e) => this.handleIngredientSearch(e.target.value, index)}
                                                            onFocus={() => this.handleIngredientInputFocus(index)}
                                                            onBlur={this.handleIngredientInputBlur}
                                                            disabled={loadingParts}
                                                            autoComplete="off"
                                                            style={{ fontSize: '14px' }}
                                                        />
                                                        {this.state.showIngredientDropdown && this.state.activeDropdownIndex === index && (
                                                            <div className="dropdown-list">
                                                                {this.state.filteredIngredients.length > 0 ? (
                                                                    this.state.filteredIngredients.slice(0, 50).map(part => (
                                                                        <div
                                                                            key={part.id}
                                                                            className="dropdown-item-custom"
                                                                            onMouseDown={() => this.selectIngredient(part, index)}
                                                                        >
                                                                            <strong>{part.id}</strong> - {part.name}
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <div className="no-results">
                                                                        {loadingParts ? 'Loading ingredients...' : 'No matching ingredients found'}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col md={1}>
                                                   
                                                    <Form.Group className="mb-2">
                                                        <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Label Claim</Form.Label>
                                                       
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                placeholder="Label Claim"
                                                                readOnly
                                                                value={part.Amount || ''}
                                                                onChange={(e) => this.handleIngredientPartChange(index, 'Amount', e.target.value)}
                                                                style={{ fontSize: '14px', backgroundColor: '#f8f9fa', color: '#6c757d' }}
                                                            />
                                                    </Form.Group>
                                             
                                                </Col>
                                                <Col md={1}>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Unit</Form.Label>
                                                         <div className="d-flex align-items-center">
                                                            <Form.Select
                                                                size="sm"
                                                                style={{ fontSize: '13px', padding: '0.25rem 0.3rem', backgroundColor: '#f8f9fa', color: '#6c757d' }}
                                                                value={part.Unit || ''}
                                                                readOnly
                                                                onChange={(e) => this.handleIngredientPartChange(index, 'Unit', e.target.value)}
                                                            >
                                                                <option value=""></option>
                                                                <option value="g">g</option>
                                                                <option value="mg">mg</option>
                                                                <option value="mcg">mcg</option>
                                                                <option value="IU">IU</option>
                                                                <option value="CFU">CFU</option>
                                                            </Form.Select>

                                                            {this.shouldShowCalculator(part) && (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => this.handleOpenCalculatorModal(index)}
                                                                    style={{
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        color: '#007BFF',
                                                                        cursor: 'pointer',
                                                                        fontSize: '24px',
                                                                        padding: '2px',
                                                                        marginLeft: '3px'
                                                                    }}
                                                                    title="Open Calculator"
                                                                >
                                                                    <i class="fa-solid fa-calculator"></i>
                                                                </button>
                                                            )}
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={2}>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Amount (g)</Form.Label>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                placeholder="0.000"
                                                                value={part.AmountPerServing || '0.000'}
                                                                readOnly
                                                                style={{
                                                                    fontSize: '14px',
                                                                    textAlign: 'center',
                                                                    marginRight: '4px',
                                                                    backgroundColor: '#f8f9fa',
                                                                    color: '#6c757d'
                                                                }}
                                                                title="Calculated from Label Claim and Unit"
                                                            />
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={1}>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Overage %</Form.Label>
                                                        <Form.Control
                                                            size="sm"
                                                            type="number"
                                                            placeholder="100"
                                                            value={part.Overage}
                                                            onChange={(e) => this.handleIngredientPartChange(index, 'Overage', e.target.value)}
                                                            style={{ fontSize: '14px', textAlign: 'center' }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={1} className="text-center">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Source</Form.Label>
                                                        <div
                                                            onClick={() => this.toggleIngredientCSM(index)}
                                                            style={{
                                                                cursor: 'pointer',
                                                                fontSize: '14px',
                                                                color: part.IsCsm ? '#10b981' : '#6b7280',
                                                                height: '31px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                border: '1px solid transparent'
                                                            }}
                                                            title={part.IsCsm ? 'CSM' : 'Click to mark as CSM'}
                                                        >
                                                            {part.IsCsm ? 'CSM' : <i className="ti-check-box" style={{ fontSize: '18px' }}></i>}
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={1} className="text-center">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Actions</Form.Label>
                                                        <div>
                                                            <button
                                                                type="button"
                                                                style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }}
                                                                onClick={() => this.removeIngredientPart(index)}
                                                                title="Delete"
                                                                disabled={ingredientParts.length <= 1}
                                                            >
                                                                <i className="ti-trash"></i>
                                                            </button>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        ))}

                                        <Row>
                                            <Col md={12}>
                                                <button
                                                    type="button"
                                                    onClick={this.addIngredientPart}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        color: '#4FC3F7',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        padding: '8px 0'
                                                    }}
                                                >
                                                    <i className="ti-plus" style={{ marginRight: '5px' }}></i>
                                                    Add Ingredient Part
                                                </button>
                                            </Col>
                                        </Row>

                                       

                                    </div>
                                </div>
                                )}

                                {/* Capsule Section - Only show when RFQ is selected and Form is Capsule */}
                                {selectedRfq && form === 'capsule' && (
                                    <div className="form-section">
                                    <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Capsule</h5>
                                        <Button
                                            variant="info"
                                            size="sm"
                                            style={{ backgroundColor: '#007BFF', border: 'none', fontSize: '12px', padding: '4px 8px' }}
                                            onClick={this.handleOpenAddRawsModal}
                                        >
                                            Create New Part
                                        </Button>
                                    </div>
                                    <div className="section-content">
                                        <Row className="align-items-end" style={{ marginBottom: '10px' }}>
                                            <Col md={6}>
                                                <Form.Group className="mb-2">
                                                    <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Part ID#</Form.Label>
                                                    <Form.Control
                                                        size="sm"
                                                        placeholder="Part ID#"
                                                        value={this.state.capsule.PartID}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const matchingPart = this.state.filteredCapsuleParts.find(p => p.id === value);

                                                            if (matchingPart) {
                                                                this.setState({
                                                                    capsule: {
                                                                        ...this.state.capsule,
                                                                        PartID: matchingPart.id,
                                                                        PartName: matchingPart.name,
                                                                        RawsId: matchingPart.rawsId
                                                                    }
                                                                });
                                                            } else {
                                                                this.setState({
                                                                    capsule: {
                                                                        ...this.state.capsule,
                                                                        PartID: value
                                                                    }
                                                                });
                                                            }
                                                        }}
                                                        style={{ fontSize: '14px' }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-2 searchable-dropdown">
                                                    <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Part Name</Form.Label>
                                                    <Form.Control
                                                        size="sm"
                                                        type="text"
                                                        placeholder={loadingParts ? 'Loading capsules...' : 'Search Capsule'}
                                                        value={this.state.capsule.PartName || ''}
                                                        onChange={(e) => this.handleCapsuleSearch(e.target.value)}
                                                        onFocus={this.handleCapsuleInputFocus}
                                                        onBlur={this.handleCapsuleInputBlur}
                                                        disabled={loadingParts}
                                                        autoComplete="off"
                                                        style={{ fontSize: '14px' }}
                                                    />
                                                    {this.state.showCapsuleDropdown && (
                                                        <div className="dropdown-list">
                                                            {this.state.filteredCapsuleParts.length > 0 ? (
                                                                this.state.filteredCapsuleParts.slice(0, 50).map(part => (
                                                                    <div
                                                                        key={part.id}
                                                                        className="dropdown-item-custom"
                                                                        onMouseDown={() => this.selectCapsulePart(part)}
                                                                    >
                                                                        <strong>{part.id}</strong> - {part.name}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div className="no-results">
                                                                    {loadingParts ? 'Loading packaging parts...' : 'No matching packaging parts found'}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={2}>
                                                <Form.Group className="mb-2">
                                                    <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>g/Capsule</Form.Label>
                                                    <Form.Control
                                                        size="sm"
                                                        type="text"
                                                        value={this.state.capsuleWeight || ''}
                                                        readOnly
                                                        disabled
                                                        style={{ fontSize: '14px', backgroundColor: '#f3f4f6' }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                )}

                                {/* Packaging Parts Section - Multiple sections based on Servings/Unit */}
                                {selectedRfq && this.state.servingUnits && this.state.servingUnits.filter(u => u.ServingUnit).map((servingUnit, suIndex, filteredArray) => {
                                    const servingUnitId = servingUnit.RfqServingUnitId;
                                    const partsForThisUnit = packagingParts.filter(p => p.RfqServingUnitId === servingUnitId);
                                    const hasMultipleServingUnits = filteredArray.length > 1;

                                    return (
                                        <div key={suIndex} className="form-section">
                                        <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                                                {hasMultipleServingUnits
                                                    ? `Packaging Parts - ${servingUnit.ServingUnit} Counts`
                                                    : 'Packaging Parts'}
                                            </h5>
                                        <Button
                                            variant="info"
                                            size="sm"
                                            style={{ backgroundColor: '#007BFF', border: 'none', fontSize: '12px', padding: '4px 8px' }}
                                            onClick={this.handleOpenAddRawsModal}
                                        >
                                            Create New Part
                                        </Button>
                                    </div>
                                        <div className="section-content">
                                            {partsForThisUnit.map((part, index) => {
                                                const globalIndex = packagingParts.indexOf(part);
                                                return (
                                                    <Row key={globalIndex} className={`align-items-end${part.deleted === true ? ' hide-me' : ''}`} style={{ marginBottom: '10px' }}>
                                                        <Col md={3}>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Part ID#</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    placeholder="Part ID#"
                                                                    value={part.PartID}
                                                                    onChange={(e) => this.handlePartIdChange(globalIndex, e.target.value, 'packaging')}
                                                                    style={{ fontSize: '14px' }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={4}>
                                                            <Form.Group className="mb-2 searchable-dropdown">
                                                                <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Part Name</Form.Label>
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    placeholder={loadingParts ? 'Loading parts...' : 'Search packaging parts...'}
                                                                    value={part.PartName || ''}
                                                                    onChange={(e) => this.handlePackagingSearch(e.target.value, globalIndex)}
                                                                    onFocus={() => this.handlePackagingInputFocus(globalIndex)}
                                                                    onBlur={this.handlePackagingInputBlur}
                                                                    disabled={loadingParts}
                                                                    autoComplete="off"
                                                                    style={{ fontSize: '14px' }}
                                                                />
                                                                {this.state.showPackagingDropdown && this.state.activePackagingDropdownIndex === globalIndex && (
                                                                    <div className="dropdown-list">
                                                                        {this.state.filteredPackagingParts.length > 0 ? (
                                                                            this.state.filteredPackagingParts.slice(0, 50).map(part => (
                                                                                <div
                                                                                    key={part.id}
                                                                                    className="dropdown-item-custom"
                                                                                    onMouseDown={() => this.selectPackagingPart(part, globalIndex)}
                                                                                >
                                                                                    <strong>{part.id}</strong> - {part.name}
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <div className="no-results">
                                                                                {loadingParts ? 'Loading packaging parts...' : 'No matching packaging parts found'}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={1} className="text-center">
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Source</Form.Label>
                                                                <div
                                                                    onClick={() => this.togglePackagingCSM(globalIndex)}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        fontSize: '14px',
                                                                        color: part.IsCsm ? '#10b981' : '#6b7280',
                                                                        height: '31px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        border: '1px solid transparent'
                                                                    }}
                                                                    title={part.IsCsm ? 'CSM' : 'Click to mark as CSM'}
                                                                >
                                                                    {part.IsCsm ? 'CSM' : <i className="ti-check-box" style={{ fontSize: '18px' }}></i>}
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={1} className="text-center">
                                                            <Form.Group className="mb-2">
                                                                <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Actions</Form.Label>
                                                                <div>
                                                                    <button
                                                                        type="button"
                                                                        style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }}
                                                                        onClick={() => this.removePackagingPart(globalIndex)}
                                                                        title="Delete"
                                                                    >
                                                                        <i className="ti-trash"></i>
                                                                    </button>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={3}>
                                                            {/* Empty column for spacing */}
                                                        </Col>
                                                {/* <Col md={1}>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Amount Each</Form.Label>
                                                        <Form.Control
                                                            size="sm"
                                                            type="number"
                                                            placeholder="0"
                                                            value={part.amountEach}
                                                            onChange={(e) => this.handlePackagingPartChange(index, 'amountEach', e.target.value)}
                                                            style={{ fontSize: '14px', textAlign: 'center' }}
                                                        />
                                                    </Form.Group>
                                                </Col> */}

                                                    </Row>
                                                );
                                            })}

                                            <Row>
                                                <Col md={12}>
                                                    <button
                                                        type="button"
                                                        onClick={() => this.addPackagingPart(servingUnitId)}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            color: '#4FC3F7',
                                                            cursor: 'pointer',
                                                            fontSize: '14px',
                                                            padding: '8px 0'
                                                        }}
                                                    >
                                                        <i className="ti-plus" style={{ marginRight: '5px' }}></i>
                                                        Add Packaging Part
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    );
                                })}

                                {/* Testing Section */}
                                <div className="form-section">
                                    <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Testing</h5>
                                        <Button
                                            variant="info"
                                            size="sm"
                                            style={{ backgroundColor: '#4FC3F7', border: 'none', fontSize: '12px', padding: '4px 12px' }}
                                            onClick={this.addTestingItem}
                                        >
                                            <i className="ti-plus" style={{ marginRight: '5px' }}></i>
                                            Add New Test
                                        </Button>
                                    </div>
                                    <div className="section-content">
                                        <div style={{ overflowX: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <thead style={{ backgroundColor: '#f8f9fa' }}>
                                                    <tr>
                                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600', color: '#6b7280', fontSize: '14px' }}>Testing Type</th>
                                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600', color: '#6b7280', fontSize: '14px' }}>Cost</th>
                                                        <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', color: '#6b7280', fontSize: '14px' }}></th>
                                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600', color: '#6b7280', fontSize: '14px' }}>Number of Ingredients</th>
                                                        <th style={{ padding: '12px', textAlign: 'right', fontWeight: '600', color: '#6b7280', fontSize: '14px' }}>Total</th>
                                                        <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', color: '#6b7280', fontSize: '14px' }}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.testingItems.filter(item => !item.deleted).map((item, index) => {
                                                        // Get the actual index in the original array for updates
                                                        const actualIndex = this.state.testingItems.indexOf(item);
                                                        return (
                                                            <tr key={actualIndex} style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                                <td style={{ padding: '12px' }}>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Testing Type"
                                                                        value={item.testingType}
                                                                        onChange={(e) => this.handleTestingChange(actualIndex, 'testingType', e.target.value)}
                                                                        style={{ fontSize: '14px' }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '12px', width: '120px' }}>
                                                                    <Form.Control
                                                                        type="number"
                                                                        placeholder="0"
                                                                        value={item.cost}
                                                                        onChange={(e) => this.handleTestingChange(actualIndex, 'cost', e.target.value)}
                                                                        style={{ fontSize: '14px' }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '12px', textAlign: 'center', fontSize: '18px', color: '#6b7280' }}>
                                                                    ×
                                                                </td>
                                                                <td style={{ padding: '12px', width: '150px' }}>
                                                                    <Form.Control
                                                                        type="number"
                                                                        placeholder="0"
                                                                        value={item.numberOfIngredients}
                                                                        onChange={(e) => this.handleTestingChange(actualIndex, 'numberOfIngredients', e.target.value)}
                                                                        style={{ fontSize: '14px' }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '12px', textAlign: 'right', fontWeight: '500', fontSize: '14px' }}>
                                                                    ${((parseFloat(item.cost) || 0) * (parseInt(item.numberOfIngredients) || 0)).toFixed(2)}
                                                                </td>
                                                                <td style={{ padding: '12px', textAlign: 'center' }}>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => this.removeTestingItem(actualIndex)}
                                                                        style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '18px' }}
                                                                        title="Delete"
                                                                    >
                                                                        <i className="ti-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}

                                                    <tr style={{ borderTop: '1px solid #e5e7eb' }}>
                                                        <td style={{ padding: '12px' }}>
                                                            <span style={{ fontWeight: '600', fontSize: '16px' }}>Testing Total</span>
                                                        </td>
                                                        <td style={{ padding: '12px', width: '120px' }}></td>
                                                        <td style={{ padding: '12px' }}></td>
                                                        <td style={{ padding: '12px', width: '150px', textAlign: 'right' }}>
                                                            
                                                        </td>
                                                        <td style={{ padding: '12px', textAlign: 'right' }}>
                                                            <span style={{ fontWeight: '600', fontSize: '18px', color: '#000' }}>
                                                                ${this.calculateTestingTotal().toFixed(2)}
                                                            </span>
                                                        </td>
                                                        <td style={{ padding: '12px', textAlign: 'center' }}></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                
                                        </div>
                                    </div>
                                </div>

                                {/* Notes Section */}
                                <div className="form-section">
                                    <div className="section-header">
                                        <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Notes</h5>
                                    </div>
                                    <div className="section-content">
                                        <NotesSection
                                            notesList={this.state.notesList}
                                            currentNote={this.state.currentNote}
                                            showAllNotes={this.state.showAllNotes}
                                            onCurrentNoteChange={(e, newValue) => this.setState({ currentNote: newValue })}
                                            onAddNote={async () => {
                                                if (this.state.currentNote.trim()) {
                                                    // If RFQ is selected, save directly to database
                                                    if (this.state.selectedRfq && this.state.selectedRfq.id) {
                                                        const success = await this.saveNoteToDatabase(
                                                            this.state.currentNote.trim()
                                                        );

                                                        if (success) {
                                                            // Reload notes to get the saved note with correct username
                                                            await this.loadNotesFromDatabase();

                                                            // Clear current note
                                                            this.setState({
                                                                currentNote: ''
                                                            });
                                                        }
                                                    } else {
                                                        // No RFQ selected yet, add to local state
                                                        const newNote = {
                                                            RfqNoteId: 0,
                                                            RfqId: 0,
                                                            NoteText: this.state.currentNote.trim(),
                                                            UserId: 0,
                                                            Username: 'Unknown',
                                                            CreatedDateTime: new Date().toISOString()
                                                        };

                                                        this.setState(prevState => ({
                                                            notesList: [...prevState.notesList, newNote],
                                                            currentNote: ''
                                                        }));
                                                    }
                                                }
                                            }}
                                            onToggleShowAll={() => this.setState({ showAllNotes: true })}
                                            onAddReply={async (parentNote, replyText) => {
                                                // If RFQ is selected, save directly to database
                                                if (this.state.selectedRfq && this.state.selectedRfq.id) {
                                                    console.log('AddNewFormula - Adding reply to note:', parentNote.RfqNoteId);
                                                    const success = await this.saveReplyToDatabase(parentNote, replyText);

                                                    console.log('AddNewFormula - Reply save success:', success);
                                                    if (success) {
                                                        // Small delay to ensure database commit completes
                                                        await new Promise(resolve => setTimeout(resolve, 300));

                                                        // Reload notes to get the saved reply with correct username
                                                        console.log('AddNewFormula - Reloading notes...');
                                                        await this.loadNotesFromDatabase();
                                                        console.log('AddNewFormula - Notes reloaded, notesList:', this.state.notesList);
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Action Buttons */}
                                { (this.state.historyId === null  || this.state.historyId === undefined) && (
                                    <div className="d-flex justify-content-end mb-5" style={{ gap: '20px' }}>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={this.handleBackToRfq}
                                            disabled={!selectedRfq}
                                        >
                                            Back to RFQ
                                        </Button>
                                        <Button
                                            variant="secondary"
                                            onClick={this.handleSaveDraft}
                                            disabled={savingDraft || loading || !selectedRfq}
                                        >
                                            {savingDraft ? 'Saving...' : 'Save R&D'}
                                        </Button>
                                        <Button
                                            variant="primary"
                                            onClick={this.handleUpdate}
                                            disabled={loading || savingDraft || !selectedRfq}
                                        >
                                            {loading ? 'Submitting...' : 'Submit to Estimate'}
                                        </Button>
                                    </div>
                                )}

                            </Form>
                        </div>
                    </section>
                </div>

                {/* Add Raws Modal */}
                <AddRawsModal
                    show={showAddRawsModal}
                    onHide={this.handleCloseAddRawsModal}
                    onSave={this.handleRawMaterialSaved}
                />

                {/* Calculator Modal */}
                <Modal
                    show={showCalculatorModal}
                    onHide={this.handleCloseCalculatorModal}
                    centered
                    size="md"
                >
                    <Modal.Header
                        closeButton
                        style={{
                            borderBottom: 'none',
                            paddingBottom: '0',
                            background: 'white'
                        }}
                    >
                        <Modal.Title style={{ fontSize: '18px', fontWeight: '600' }}>
                            Calculate Ingredient Amount
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '20px' }}>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px' }}>
                                    Label Claim
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={(() => {
                                            let labelClaim = calculatorData.amount + " " + calculatorData.unit
                                            return labelClaim;
                                        })()}
                                        disabled
                                    style={{
                                        border: '1px solid #d1d5db',
                                        fontSize: '14px'
                                    }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px' }}>
                                    Active/Inactive
                                </Form.Label>
                                <Form.Select
                                    value={calculatorData.activeInactiveOption}
                                    onChange={(e) => this.handleCalculatorDataChange('activeInactiveOption', e.target.value)}
                                    style={{
                                        border: '1px solid #d1d5db',
                                        fontSize: '14px'
                                    }}
                                >
                                    {calculatorData.activeInactiveOptions.map((option, idx) => (
                                        <option key={idx} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>

                            {(calculatorData.activeInactiveOption === "Active") && (
                                <>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px' }}>
                                            Select Limit
                                        </Form.Label>
                                        <Form.Select
                                            value={calculatorData.selectedLimit}
                                            onChange={(e) => this.handleCalculatorDataChange('selectedLimit', e.target.value)}
                                            style={{
                                                border: '1px solid #d1d5db',
                                                fontSize: '14px'
                                            }}
                                            disabled={calculatorData.limitOptions.length === 0}
                                        >
                                            <option value="">
                                                {calculatorData.limitOptions.length === 0
                                                    ? 'No active ingredients available'
                                                    : 'Select active ingredient'}
                                            </option>
                                            {calculatorData.limitOptions.map((option, idx) => (
                                                <option key={idx} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {calculatorData.limitOptions.length === 0 && (
                                            <Form.Text className="text-muted">
                                                No Active1 or Active2 values found for the selected part
                                            </Form.Text>
                                        )}
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px' }}>
                                            Limit
                                        </Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Enter limit"
                                            value={calculatorData.limit}
                                            onChange={(e) => this.handleCalculatorDataChange('limit', e.target.value)}
                                            disabled
                                            style={{
                                                backgroundColor: calculatorData.selectedActive !== '' ? '#f3f4f6' : 'white',
                                                border: '1px solid #d1d5db',
                                                fontSize: '14px'
                                            }}
                                        />
                                    </Form.Group>
                                </>
                            )}

                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px' }}>
                                    Amount Required/Serving (mg)
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    value={calculatorData.amountRequiredPerServing || ''}
                                    onChange={(e) => this.handleCalculatorDataChange('amountRequiredPerServing', e.target.value)}
                                    style={{
                                        border: '1px solid #d1d5db',
                                        fontSize: '14px'
                                    }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px' }}>
                                    Amount Required/Capsule (g)
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    value={calculatorData.amountRequiredPerCapsule || ''}
                                    onChange={(e) => this.handleCalculatorDataChange('amountRequiredPerCapsule', e.target.value)}
                                    style={{
                                        border: '1px solid #d1d5db',
                                        fontSize: '14px'
                                    }}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: 'none', paddingTop: '0' }}>
                        <Button
                            variant="secondary"
                            onClick={this.handleCloseCalculatorModal}
                            style={{
                                fontSize: '14px',
                                padding: '8px 20px',
                                backgroundColor: 'white',
                                color: '#6b7280',
                                border: '1px solid #d1d5db'
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={this.handleCalculatorApply}
                            style={{
                                fontSize: '14px',
                                padding: '8px 24px',
                                backgroundColor: '#3b82f6',
                                border: 'none'
                            }}
                        >
                            Apply
                        </Button>
                    </Modal.Footer>
                </Modal>

                {this.state.selectedRfq && this.state.selectedRfq.id && (
                    <AuditLogSection entityType="rfq" entityId={this.state.selectedRfq.id} />
                )}
            </Layout>
        );
    }
}

export default AddNewFormula;